export default {
  ActionConfirm: "Аракетинизди тастыктаныз",
  ActivatePromocode: "Промокодду активдештирүү",
  AddFile: "Файлды кошуу",
  AddToFavorites: "Тандалгандарга кошуу",
  "Andar Bahar": "Андар Бахар",
  ApplyFilter: "Фильтр колдонуу",
  AppsPage: {
    blocks: {
      descriptionOne: "Актуалдуу күзгүлөрдү издөөнүн кереги жок",
      descriptionThree: "Бардык акциялар, турнирлер жана ойнотуулар жөнүндө жеке билдирүүлөр",
      descriptionTwo: "Тиркемелердин колдонуучулары үчүн уникалдуу акциялар жана сунуштар",
      titleOne: "ОЛИМП ар дайым жаныӊда",
      titleThree: "Бардык окуялардан жана сунуштардан кабардар болуӊуз",
      titleTwo: "Эксклюзивдүү акциялар жана турнирлер "
    },
    dontWorry: "Кабатыр болбоӊуз, бул коопсуз",
    howToInstall: "Кантип орнотуу керек",
    installAndroid: "Андроид үчүн жүктөө",
    installIos: "iOS үчүн орнотуу",
    installIsSafe: "Орнотуу коопсуз",
    qrText: "Тиркемени жүктөө үчүн, камераны QR-кодго алып барыӊыз ",
    safeDescription: "Google-дун биздин оюндарыбызга карата саясатынан улам биз тиркемени Play Market-ке чыгара албайбыз. Орнотуу үчүн нускаманы аткарыӊыз",
    seo: {
      all: {
        block_one: {
          description: "{platform} – бул оюн-зооктордун чоӊ ассортименти менен виртуалдык беттингдин жана гемблингдин заманбап платформасы. Биз колдонуучулардын ыңгайлуулугуна өзгөчө көңүл бурабыз, ошондуктан биздин онлайн-аянтчага каалаган түзмөктөн, компьютерден да, смартфондон да кирүүгө болот. Олимп казиносунун мобилдик тиркемеси Android жана iOS сыяктуу популярдуу операциялык системаларда иштеген бардык заманбап телефондорго ылайыкташтырылган. Кумар оюнун сүйүүчүлөр каалаган жерде, алар үчүн ыңгайлуу убакта интернет платформасынын толук мүмкүнчүлүктөрүн пайдалана алышат.",
          title: "{platform} мобилдик тиркемеси"
        },
        block_three: {
          description: "Тиркемени жүктөп алып, ага катталган ар бир оюнчу аянтчанын бардык функционалына жана куралдардын толук топтомуна ээ. Мобилдик колдонмодо эмне жеткиликтүү? Жеке кабинетиӊиз аркылуу сиз төмөнкүлөрдү аткара аласыз:",
          list: {
            five: "Оюн эсеби боюнча каржылык операциялардын – каражат чыгарууга буйрутмалардын, төлөмдөрдүн жана коюмдардын тарыхын биле аласыз.",
            four: "Бонустарды — welcome-пакет жана башка белектерди колдоно аласыз.",
            one: "Профилди ырастоо - телефон номерин же почта дарегин кошуп, өзүңүз жөнүндө маалыматты толтура жана аны өзгөртө аласыз.",
            three: "Билдирүүлөрдө казинодон келген жөнөтмөлөрдү көзөмөлдөй аласыз.",
            two: "Балансты текшерип, аны каалаган ыңгайлуу ыкма менен толтуруп, байге суммаларын чыгарып алып, тез кэшбэк ала аласыз."
          },
          text: "Катталуу процедурасынан кийин эле дароо Олимп казиносун онлайн ойносоӊуз жана коюмдарды койсоӊуз болот. Болгону минималдуу депозитти салып, өзүңүзгө жаккан көңүл ачууну тандап алышыңыз керек — биздин тиркемеде оюн автоматтары, лотереялар, тез, спорттук жана классикалык оюндар, live-казино, спортко коюмдар жана ар кандай турнирлер бар. Olymp Casino тиркемесинде онлайн-сессия учурунда кандайдыр бир суроолоруңуз пайда болсо, сизге техникалык колдоо жардамга келет. Болгону чатты ачып, атайын формада билдирүү калтыруу жетиштүү.",
          title: "Функционалдуу"
        },
        block_two: {
          description: "Тиркемелер дүкөндөрү - Google Play Market, AppGallery жана башка маркеттер - кумар оюндарына байланыштуу ар кандай саясаттарды сакташат жана өз каталогдоруна керектүү софтту дайыма эле жайгаштыра бербейт. Биз сиз үчүн издөө процессин жөнөкөйлөштүрдүк жана Олимп казиносунун мобилдик тиркемесин бардык ОСтер үчүн ачык жеткиликте жайгаштырдык - аны биздин расмий сайттан түз жүктөп алуу оңой. Сиз төмөнкү аракеттер алгоритмдердин бирин тандай аласыз:",
          list: {
            one: "Компьютерди колдонуу. Бул үчүн каалаган браузер аркылуу расмий {platform} расмий порталын ишке киргизиңиз же издөө системасы аркылуу жумушчу күзгүнү ачыңыз. Ал жерден «IOS үчүн орнотуу» жана «Андроид үчүн жүктөө» баскычтары бар баракчаны табасыз. Ылайыктуу вариантты басып, телефондун камерасы аркылуу QR-кодду сканерлеңиз. Анын экранында шилтеме пайда болот – ага өтүӊүз. Эгер сиз iPhone колдонсоӊуз, сиз аны жүктөп алуу үчүн App Store-догу тиркемебизге багытталасыз. Эгер сизде Android болсо, тиркемени орнотууга уруксат берип, анын аяктоосун күтүшүңүз керек.",
            two: "Мобилдик түзмөктөрдү колдонуу. {platformSite} сайтына кириӊиз – Олимп мобилдик версиясы ачылат. Тиркемени акысыз жүктөп алуу үчүн, алгач смартфонуңуздун ОСине жараша эки жүктөө баскычынан керектүүсүн тандаңыз. Адегенде телефонуңуздун «Ырастамаларына» кирип, белгисиз файлдарды орнотууга уруксат берүүнү унутпаңыз – бул коопсуз. Тиркеме бир нече мүнөт ичинде жүктөлөт"
          },
          text: "«Кирүү» баскычын басып, авторизацияга өтүӊүз. Эгер {platform}-до аккаунтуңуз жок болсо, азыр аны жасоого убакыт келди. Тиешелүү талааларга телефон номериңизди же e-mail-иӊизди жазып, жакшы сырсөз ойлоп таап, аракетти ырастаңыз.",
          title: "Тиркемени кайдан жүктөсө болот"
        }
      },
      android: {
        block_four: {
          description: "{platform} мобилдик тиркемеси англис, казак, өзбек, кыргыз жана орус тилдеринде иштейт – аны каалаган убакта өзгөртө аласыз. Тиркеме максималдуу комфорт менен телефон аркылуу колдонууга ылайыкташтырылган - мобилдик экрандардын өлчөмүн эске алуу менен интерфейстин бардык элементтери бул жерге жылдырылган. Ар бир ыйгарым укуктуу смартфондун ээси үчүн сайттын десктоптук версиясынын бардык функциялары жеткиликтүү:\n\n",
          list: {
            five: "Жекее билдирүүлөр.",
            four: "Төлөмдөрдүн, коюмдардын жана акча каражатын чыгарууга болгон буйрутмалардын тарыхы.",
            one: "Профилдин ырастамалары",
            three: "Промокоддор жана белектер – фриспиндер, акысыз коюмдар жана депозитке бонустар.",
            two: "Оюн эсеби менен операциялар – толуктоо, чыгаруу жана ыкчам кешбэк.\n\n"
          },
          text: "Жана эң негизгиси, телефон же планшет аркылуу сизди кызыктырган каалаган оюндарды сынап көрүп, спорттук мелдештерде бактыңызды сынап, акцияларга жана турнирлерге катыша аласыз. Олимп Казиносу ар дайым сиздин колуңузда болот, ал эми жеке билдирүүлөрдүн аркасы менен сиз эксклюзивдүү сунуштарды өткөрүп жибербейсиз.",
          title: "Функционалдуу"
        },
        block_one: {
          description: "{platform}-до жайгашкан жерине карабастан, ырахат менен эс алууну каалагандар үчүн кумар оюндарынын бай коллекциясы чогултулган. Спортко коюмдар жана лотереялар, тез жана бет оюндар, live-казино жана слоттор – оюн софту сизге телефонуңуздан жеткиликтүү! Андроид операциялык системасынын негизиндеги смартфондордун ээлери баарына ээ боло алышат – атайын сиздер үчүн биз Андроид базасындагы Олимп атайын мобилдик тиркемесин иштеп чыктык. Телефон же планшет аркылуу жеке эсебиӊизди толуктап, сүйүктүү автоматтарыңызды жана слотторду онлайн режиминде ачып, процесстен ырахат алыңыз.",
          title: "Android үчүн Олимп Казино тиркемеси"
        },
        block_three: {
          description: "Android-ге расмий сайттан Олимп тиркемесин акысыз жүктөйүн деп жатасызбы? Мобилдик түзмөгүңүздү APK-файлдарын орнотууга даярдашыңыз керек. Биринчиден, керектүү уруксаттарды иштетиңиз:",
          list: {
            four: "Экранда «Бул булактан орнотууга уруксат берүү» деген эскертүү пайда болгондо, жүктөөнү баштоо үчүн баскычты басыңыз.",
            one: "Смартфондогу  «Ырастамаларга» өтүп, «Тиркемелер» пунктун табыӊыз.",
            three: "Белгисиз тиркемелерди орнотуу үчүн жеткиликти камсыздаӊыз.",
            two: "«Уруксаттар» менюсун ачыӊыз."
          },
          text: "Андроидге Олимп тиркемесин порталдын десктоптук версиясы аркылуу QR-кодду колдонуу менен жүктөсө болот. Ал түз эле баракчада пайда болот – болгону смартфонуңуздун камерасын кодго алып барып, жүктөө үчүн шилтемени күтүү керек. Olymp Casino мобилдик версиясы менен орнотуу процесси бир нече жөнөкөй кадамдарды талап кылат. Тиркемени смартфон аркылуу жүктөп алуу үчүн браузериңизден порталдын мобилдик версиясын ачыңыз. Ал жерден сиз «Тиркемени жүктөө» баскычын көрөсүз. Аны басыңыз – сиз «Жүктөө» деген жазууну көрөсүз. Орнотуу үчүн шилтемелерди басыӊыз – бул коопсуз, файл ишенимдүү булактан жүктөлөт. Даяр! Мобилдик тиркеменин бардык артыкчылыктарынан ырахаттана берсеӊиз болот. Эми сиз жумушчу күзгүлөрдү издөө же VPN орнотуу зарылдыгынан кутулдуңуз – Olymp Casino мобилдик тиркемеси Интернетке кирүү мүмкүнчүлүгүңүз болуп турган учурда иштей берет. Эгер бул тиркемени эң акыркы версияга чейин жаңыртуу керек болсо, баары туура иштөөсү үчүн, аны жаӊыртып алыӊыз.",
          title: "Орнотуу боюнча нускама"
        },
        block_two: {
          description: "Android үчүн {platform} мобилдик тиркемеси – бул эң мыкты кумар оюндары жана спортко коюмдар дүйнөсүнө болгон сиздин жол көрсөтүүчүӊүз. Аны кайдан жүктөө керек? Google Play Market, AppGallery же башка ушул сыяктуу тиркемелер дүкөндөрү сыяктуу Android үчүн мобилдик маркеттерде кумар оюндарына байланыштуу атайын саясаттар бар. Ал жерде сиз үчүнчү тараптын иштеп чыгуучуларынын долбоорлорун гана таба аласыз. Алардын Olymp Casino расмий сайтына эч кандай тиешеси жок. Биздин түпнуска тиркемебизди табуу үчүн компьютериңизден же мобилдик түзмөгүңүздөн негизги olymp.casino сайтын ачышыӊыз керек.",
          title: "Тиркемени кайдан жүктөсө болот"
        }
      },
      ios: {
        block_one: {
          description: "IPhone жана iPad ээлеринин арасында {platform} кумар оюндарынын көптөгөн күйөрмандары бар. iOS операциялык системасынын негизиндеги түзмөктөр үчүн мобилдик тиркемебиз колдонуучулар үчүн кеңири мүмкүнчүлүктөрдү ачып, аракеттердин толук эркиндигин камсыз кылат. Каалаган убакта сиздин чөнтөгүңүздө тинтернет-казинонун толук функционалы менен көңүл ачуунун чоң каталогу болот. Каражаттарды эсепке салыӊыз, профилиңиздин маалыматтарын башкарыӊыз, каалаган өлчөмдөгү байге суммаларын чыгарып алыӊыз, онлайн режиминде ойноңуз жана күн сайын жаңы нерсени байкап көрүңүз. iOS үчүн Олимп казиносунун мобилдик тиркемеси сизге ушунчалык көп ырахат алууга жана канча кааласаӊыз, ошончо пайда алууга жардам берет! Бул үчүн сиз телефонуңузду же планшетиңизди туура «жабдып», көңүл ачууга өтүӊүз.",
          title: "iPhone үчүн Олимп Казино iOS тиркемеси"
        },
        block_three: {
          description: "iOS базасындагы түзмөктөр үчүн Олимп казиносунун тиркемеси сизге платформадагы кумар оюндарынын бардык коллекциясына – көптөгөн слотторго, стол оюндарына, спорттук жана краш-оюндарга, столдорго, лотереяларга, акцияларга, турнирлерге толук мүмкүнчүлүк берет. Мобилдик тиркемедеги өзүңүздүн жеке кабинетиңиз аркылуу сиз керектүү аракеттерди жасай аласыз:",
          list: {
            five: "Операциялардын – акча чыгарууга болгон бардык буйрутмалардын, транзакциялардын жана коюмдардын тарыхын көрө аласыз.",
            four: "Казинодон келген билдирүүлөрдү окуй аласыз.\n\n",
            one: "Профилдеги жеке маалыматтарды өзгөртүп, верификаицяга өтө аласыз.",
            three: "Белектерди алып, активдештирип, кайра ойной аласыз – анын ичинде жаӊы келгендер үчүн welcome-бонус.",
            two: "Эсепти толуктап, утушту чыгарып алып, ыкчам кешбэк ала аласыз."
          },
          text: "Атайын мобилдик тиркеменин колдонуучулары үчүн көптөгөн уникалдуу сунуштар каралган: бардык окуялардан кабардар болуу жана пайдалуу акциялар, актуалдуу ойнотуулар жана эксклюзивдүү турнирлер тууралуу өз убагында билүү үчүн эскертмелерди күйгүзүүнү унутпаңыз. Депозитти толтурууга, коюмдарды коюуга, оюн автоматтарын «сыноого» жана бактыңызды тартууга убакыт келди. Olymp казиносунун тиркемесиндеги ар бир виртуалдык сессия сизге жагымдуу гана таасирлерди калтыруусуна кам көрдүк.\n\n",
          title: "Функционал жана мүмкүнчүлүктөр"
        },
        block_two: {
          description: "Биз колдонуучуларды оюн үчүн керектүү курал менен кантип натыйжалуу жана ыңгайлуу камсыз кылууну билебиз. {platform} мобилдик тиркемеси Apple фирмалык дүкөнүндө жеткиликтүү – ал бекер. iOS үчүн расмий Олимп тиркемесин жүктөп алуу үчүн, App Store дүкөнүнөн аны жүктөп алууга шилтеме алышыңыз керек. Муну жасоонун эки жолу бар – сиз ыңгайлуураагын тандап алсаӊыз болот:",
          list: {
            one: "Компьютериңизден Олимп казиносунун расмий сайтын ишке киргизиңиз жана мобилдик тиркемеге шилтемеси бар баракчага өтүңүз. Ал жерден сиз QR-кодду көрөсүз – түзмөгүңүздүн камерасын ага алып барып, жүктөп алуу үчүн шилтемени басыңыз.",
            two: "iOS платформасында түзмөгүңүз аркылуу {platformSite} порталына түз өтүңүз — мобилдик версия ачылат. Олимп тиркемесин iPhone-го же iPad-га ушундай жол менен жүктөп алуу үчүн «iOS үчүн орнотуу» баскычын басыӊыз. Сиз App Store-го багытталасыз – жана сиз тиркемени орнотуп баштасаңыз болот."
          },
          text: "Жүктөө аяктагандан кийин, системада аккаунт түзсөӊүз же жеке кабинетиӊиз болсо, авторизацияланып, эң кызыктуу бөлүгүнө - {platform} көңүл ачуучу оюндарына өтсөңүз болот!",
          title: "Тиркемени орнотуу оӊой"
        }
      }
    },
    seoText: "-",
    seoTitle: "SEO тексти",
    slider: {
      textEight: "Сайттан «Тиркемени жүктөө» баскычын басыӊыз",
      textFive: "«Орнотуу» баскычын басыӊыз",
      textFour: "Тиркеменин жүктөлгөн файлын басыӊыз",
      textOne: "Жүктөөнү баштоо үчүн, «Жүктөө» баскычын басыӊыз",
      textSeven: "Телефондун камерасын QR кодго алып келип, сайтка кириӊиз",
      textSix: "Тиркемени иш столунан ачып, ойноӊуз",
      textThree: "Белгисиз булактардан алынган тиркемелерди орнотууга уруксат",
      textTwo: "«Белгисиз тиркемелерди орнотуу» бөлүмүнө кириӊиз"
    },
    slides: {
      allowInstall: "Белгисиз булактардан алынгандарды орнотууга уруксат берүү",
      cancel: "Жокко чыгаруу",
      download: "Жүктөө",
      downloadApp: "Тиркемени жүктөө",
      downloadIsDone: "Жүктөө аяктады",
      installUnknownApp: "Белгисиз тиркемелерди орнотуу",
      isntall: "Орнотуу",
      moveToSite: "Сайтка өтүү",
      myFiles: "Менин файлдарым",
      safeDescription: "Play Market-тен тышкары тиркемелерди орнотуу. Файлды бир гана ишенимдүү булактан жүктөӊүз",
      settings: "Ырастамалар"
    },
    textForMobile: {
      androidAndIos: "Андроидге жана iOS-ко",
      downloadOnAndroid: "Андроидге жүктөө",
      downloadOnAndroidAndIos: "Андроидге жана iOS-ко жүктөө",
      downloadOnIos: "iOS-ко жүктөө",
      onAndroid: "Андроидге",
      onIos: "iOS-ко"
    },
    title: "Олимп тиркемеси"
  },
  Aviator: "Aviator",
  Basket: "Себет",
  BeforeEndPromotion: "Акциянын аягына чейин",
  BeforeStartPromotion: "Акциянын башына чейин",
  Betgames: "Betgames",
  Bets: "Коюмдар",
  BonusBalanceOff: "Сиз казинонун негизги балансына өттүңүз. Эсепти толуктап сүйүктүү оюндарыңызды ойноңуз.",
  BonusBalanceOn: "Сиз бонустук баланска өттүңүз.",
  BonusesAndPromotions: "Бонустар жана акциялар",
  BonusesAndPromotionsSection: "Бонустар жана акциялар бөлүмү",
  Categories: "Категориялар",
  Chat: "Чат",
  CloseMatchTracker: "Матч-трекерди жабуу\n\n",
  CoefficientChanged: "Коэффициент өзгөрдү",
  ContactSupport: "Колдоого кайрылыӊыз",
  "Cricket X": "Крикет X",
  DeleteConfirm: "Өчүрүүнү тастыктоо",
  DeleteConfirmText: "Сиз мурда жүктөлгөн файлдарды өчүрүүнү каалайсызбы?",
  DeleteFiles: "Файлдарды өчүрүү",
  DenyReason: "Төмөнкү себеп боюнча четке кагылды",
  DocumentAlreadyAttached: "Бул файл мурдатан тиркелген",
  DocumentDoesntMeetRequirements: "Документ талаптарга жооп бербейт",
  DocumentResolutionTooBig: "Сүрөттүн чечилиши өтө жогору. Максималдуу жол берилген - {value} Mп",
  DocumentsFilesLimits: "(файлддын макс. саны - {fields}, файлдын макс. өлчөмү - {size} Мб)",
  DocumentsUploadError: "Файлдарды жүктөөдө ката кетти - {files}. Калган файлдар текшерүүгө жөнөтүлдү. Сиз бул файлдарды кайрадан жүктөп көрсөӊүз болот",
  DownloadOn: "Жүктөө",
  EuroLanding: {
    activate: "«Бонустар» бөлүмүнөн <br /><span>активдештириңиз</span>",
    bonusText: "<span>Фрибет</span><b>{freebet}</b><span>катталуу үчүн!</span>",
    register: "Olymp Casino сайтына <br /><span>катталыңыз</span>"
  },
  Event: "Окуя",
  Exclusive: "Exclusive",
  Expires: "Мөөнөтү өтөт",
  ForbidenBonus: "Бул күн үчүн байгелер алынган",
  Found: "Табылды",
  FruityWheel: {
    btn: "Айлантып",
    title: "Айлантып, welcome бонусуӊду билип ал"
  },
  GatesOfOlympus: {
    completeSignIn: "Каттону азыр аяктап, бонус алыӊыз",
    getBonus: "Бонусту алып кетүү",
    spin: "Айлант",
    titleFirstLine: "Дөңгөлөктү айлант ",
    titleSecondLine: "бонустарды ал",
    twist: "Айлантуу",
    youWin: "Сиз уттуӊуз",
    yourBonus: "Сиздин бонусуңуз"
  },
  GetYourPrizes: "Байгелерди алып кет",
  GoldenTimesKz: {
    bonusText: "Куттуктайбыз! Сиздин утушуңуз",
    headTitle: "Бонусуңузду <br />алыңыз жана джекпотту басыңыз!",
    labelText: "Телефон номериңизди киргизиңиз"
  },
  InformationAllPromotions: "Бардык акциялар боюнча маалымат",
  InitialCoefficient: "Баштапкы коэф.:",
  JetX: "JetX",
  LongTermRates: "Узак мөөнөттүү коюмдар",
  MainSite: "Негизги сайт",
  MatchTracker: "Матч-трекер",
  MaximizeMatchTracker: "Матч-трекерди көбөйтүү",
  MinimizeMatchTracker: "Матч-трекерди азайтуу",
  Mobile: "Мобилдик",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "/app меню пунктун тандаңыз",
    getLink: "же шилтемени Telegram боттон алыңыз",
    getLinkButton: "Шилтемени алуу",
    groups: {
      four: "Бардык<br/>окуялардан жана сунуштардан кабардар болуңуз",
      one: "<span>100 FS депозитсиз</span>тиркемени орнотуу үчүн",
      three: "Эксклюзивдүү <br/>акциялар жана турнирлер",
      two: "<br/>актуалдуу күзгүлөрдү издөөнүн кереги жок"
    },
    start: "/start",
    startText: "/start баскычын басып Telegram ботту иштетиңиз",
    successLink: "Шилтеме ийгиликтүү жөнөтүлдү",
    text: "Olymp мобилдик тиркемесин жүктөп, каалаган учурда оюнга даяр бол",
    title: "<span>100 FS <br/>депозитсиз</span>OLYMP-ти орнотуу үчүн"
  },
  MobileApplications: "Мобилдик тиркемелер",
  MyDocuments: "Менин документтерим",
  NewYearRules: {
    "1": "Акцияны өткөрүү мөөнөтү: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Aviator фрибеттери",
    "11": "JetX фрибеттери",
    "12": "Промо баракчадан бонус утуп алууда, бонус жеке кабинеттеги “Бонустар” бөлүмүнө “Бонуска өтүү” баскычын басуу жолу менен кошулат",
    "13": "Кошулган бонустарды активдештирүү 3 күндүн ичинде жеткиликтүү",
    "14": "Активдештирүүдөн кийин депозитти 1 күндүн ичинде салуу керек",
    "15": "Бонустук каражаттарды кайра ойноп утууну 1 күндүн ичинде аткаруу керек",
    "16": "Ар бир бонус боюнча кененирээк шарттар жеке кабинеттеги “Бонустар” баракчасында жеткиликтүү",
    "2": "Күн сайын промо баракчада бонус алуу үчүн 3 жолу аракет берилет",
    "3": "Аракеттердин саны акция жүрүп жаткан мөөнөт ичинде күн сайын 00:00 GMT +5 3кө чейин түшүрүлүп турат",
    "4": "Бонусту утуп алуу үчүн, колдонуучу күн сайын промо баракчага кирип, слотмашинаны SPIN баскычын басуу жолу менен иштетип турушу керек",
    "5": "SPIN баскычын ар бир басуу бир аракетти алат",
    "6": "Бонусту утуу жана бонустун түрү төмөнкүлөрдүн ичинен кокустук жолу менен аныкталат:",
    "7": "Слоттордогу депозитке бонус",
    "8": "Слоттордогу фриспиндер",
    "9": "Спортко фрибеттер"
  },
  NezlobLanding: {
    forDeposit: "депозитке",
    title: "Тамашалар түгөндү!"
  },
  NotCalculated: "Эсептелген эмес",
  NotSingleActionCurrentlyHeld: "Азыр бир дагы акция жүргөн жок",
  OlimpCasino: "Олимп казино",
  OpenFullVersion: "Толук версиясын ачуу",
  PaymentMethods: "Төлөө ыкмалары",
  PlayEveryDay: "Күн сайын ойно",
  PromoAvailableFrom: "Акция жылдын {date} тарта жеткиликтүү",
  PromoAvailableFromTo: "Акция жылдын {date1} тарта {date2} чейин жеткиликтүү",
  PromoEnded: "Акция жылдын {date} аяктады",
  Promotions: "Акциялар",
  PromotionsWillDisplayedHere: "Бул жерде акциялар көрсөтүлөт",
  QuestionAndAnswer: "Суроо – Жооп",
  RulesAcceptingBets: "«ОЛИМП» букмекердик конторасынын ставкаларын кабыл алуу эрежелери",
  RulesOfPromotion: "Акциянын эрежелери",
  RulesSingle: "Эрежелери",
  SelectTypeSystem: "Система түрүн тандаӊыз",
  Soon: "Жакында",
  Statistics: "Статистика",
  StayTuned: "Биз менен калыӊыз",
  TableContents: "Мазмуну",
  TheSearchHasNotGivenAnyResults: "Издөө натыйжа берген жок",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "Өчүрүү үчүн телефонду жана e-mail-ди тастыктоо керек",
  ToMain: "Башкы бетке",
  ToUp: "Өйдө",
  TypeBonusesAndPromotions: "Бонустардын жана акциялардын түрү",
  UntilTheNextBonus: "Кийинки бонуска чейин",
  UploadDocuments: "Жүктөлгөн файлдар",
  Version: "версиясы",
  WeAreOnSocialMedia: "Биз соц.тармактарда",
  WeOnSocialMediaFull: "Биз соц.тармактарда",
  WorldCup: "ДЧ-2022",
  YouDataProtected: "Өздүк маалыматтар жана каражаттар коопсуздукта",
  YourBonus: "Сиздин бонус",
  aboutBonus: "Бонус тууралуу кененирээк",
  acceptWithModifiedOdds: "Өзгөртүлгөн коэффициенттер менен кабыл алуу",
  acceptWithModifiedTotals: "Өзгөртүлгөн тоталдар/форалар менен кабыл алуу",
  accountApprove: "Аккаунт корголгон",
  accountNotApprove: "Аккаунт корголгон эмес",
  action: "Аракет",
  activate: "Активдештирүү",
  activateBonus: "Бонусту активдештирүү\n",
  activateFastBets: "Тез коюмдарды активдештириӊиз",
  activatingPromoCode: "Промокоддун активациясы",
  active: "Активдүү",
  activeBonusErr: "Бонусту активдештирүү үчүн, ____ кем эмес суммада депозит калды",
  activeWager: "Активдүү вейджер",
  add: "Кошуу",
  addToBasket: "Себетке кошуу",
  addYourFavoriteGames: "жардамы менен сүйүктүү оюндарыӊызды тандалгандарга кошуӊуз",
  addingDogeCoin: "Doge тыйынын кошобуз",
  additionalInfo: "Кошумча маалымат",
  addressCryptoWallet: "Крипто-капчыктын дареги",
  addressWallet: "Капчыктын дареги",
  afterInstallApp: "Сиз тиркемени орнотуу үчүн {0} бонус алдыӊыз",
  agreeTermsAndConditions: "Мен {0} менен макулмун жана менин жашым 18 жаштан жогору экенин тасткытайм",
  all: "Бардык",
  allDepositMethods: "Бардык толуктоо ыкмалары",
  allGames: "Бардык оюндар",
  allMessages: "Бардыгы",
  allMessagesButton: "Билдирүүлөргө өтүү",
  allMessagesText: "Бардык билдирүүлөр",
  allPromo: "Бардык акциялар",
  allRequiredFieldsMustBeFilled: "Бардык милдеттүү талаалар толтурулушу керек",
  allTypes: "Бардык түрлөр",
  allWithdrawMethods: "Бардык чыгаруу ыкмалары",
  all_right: "Бардык укуктар корголгон.",
  alreadyHasAccount: "Мындай аккаунт бар",
  always: "Ар дайым",
  amountOnAccount: "Эсептеги сумма",
  anUnexpectedErrorOccurred: "Алдын ала белгисиз ката кетти!",
  antifraud: {
    five: "Кардарларды көп баскычтуу текшерүү (IP боюнча текшерүү, системанын параметрлерин алуу, прокси текшерүү); Кардардын телефон номурун текшерүү; Оюнчулардын жүрүм-турумун адис тарабынан талдоо; Алдамчылыкка каршы системада төлөм маалыматтары, төлөм тарыхы жана колдонуучулардын кара тизмесин текшерүүчү 100дөн ашык фильтрлер бар; Кардар акчаны чыгаруу этабында биздин текшерүү кызматыбыз тарабынан акыркы текшерүүдөн өтөт.",
    four: "Негизги мүнөздөмөлөр",
    one: "Алдамчылыктан коргоо",
    three: "Интрнет төлөм кызматтарынын алдыңкы провайдерлери менен биргеликте биз онлайн бизнести ишенимдүү жүргүзүү жана колдонуучуларыбыздын жеке маалыматынын, ошондой эле бардык төлөм маалыматтарынын коопсуздугун камсыз кылуу үчүн болгон күчүбүздү жумшайбыз. Төлөм транзакцияларынын маалымат базасын башкаруудагы он жылдык тажрыйбабыз - Avento AntiFraud куралы кредиттик карта алдамчылыгына каршы чындап күчтүү жана ыңгайлуу куралга айланган.",
    two: "Avento AntiFraud Tool кумар оюндардын онлайн тармактарындагы алдамчылык операцияларды алдын алуу үчүн иштелип чыккан алдамчылыкка каршы күчтүү курал болуп саналат. Бул бизге кумар оюндарын ойноо мекемелеринде кредиттик карта боюнча алдамчылыктын санын бир топ кыскартууга мүмкүндүк берет."
  },
  app: "Колдонмо (тиркеме)",
  appOlymp: "Олимп тиркемеси",
  apply: "Колдонуу",
  approve: "Тастыктайм",
  approvePhoneBySms: "Номерди СМС боюнча тастыктоо",
  approvePhoneByTelegram: "Номерди Telegram аркылуу тастыктоо",
  approved: "Жактырылды",
  approvedSecond: "Тастыкталды\n\n",
  approvingWithdraw: "Каражаттарды чыгарууну тастыктоо",
  april: "апрель",
  areYouSureDeposit: "Сиздин толуктаганыӊыз аныкпы?",
  areYouSureToDeclineBonus: "Сиз чынында бонустан баш тартууну каалайсызбы?",
  areYouSureYouWantToSell: "Сиз чындыгында коюмду сатууну каалайсызбы",
  attach: "Документтерди тиркөө",
  attachDocumentsToVerifyAccount: "Верификацияны аяктап, каражаттарды чыгаруу үчүн, документтерди тиркөөңүздү суранабыз",
  attempt: "Аракет кылуу жок |1 Аракет кылуу |{count} Аракет кылуулар",
  august: "август",
  authApproveText: "Робот эмес экениӊизди текшерүү үчүн 'Тастыктайм' баскычын басыӊыз",
  authFromSocial: "Соц.тармактар аркылуу кирүү",
  authorization: "Авторизация",
  authorizationRequired: "Акы төлөнүүчү оюн авторизацияны талап кылат!",
  availabilityWallet: "Криптокапчыктын болушу {wallet}",
  available: "Қолжетімді",
  availableBonuses: "Жеткиликтүү бонустар",
  availableOnlyGameForMoney: "Акчага оюн гана жеткиликтүү",
  back: "Артка",
  backToHome: "Башкы менюга кайтуу",
  backToLogin: "Кирүү үчүн кайтуу",
  backToOneStep: "Биринчи кадамга кайтып келүү",
  balance: "Баланс",
  balanceAfterTopUp: "Толуктоодон кийинки баланс: {value}",
  balanceAfterWithdraw: "Чыгаруудан кийинки баланс: {value}",
  balanceBK: "БК балансы",
  balanceBKRefreshSuccessfully: "Баланс БК ийгиликтүү жаңыртылды",
  balanceCasino: "Казино балансы",
  balanceCasinoRefreshSuccessfully: "Баланс Casino ийгиликтүү жаңыртылды",
  balanceSwitchByWithoutBalance: "Бонустук баланска которулуу, реалдуу баланста каражаттар жок болсо, бонустук оюндарды ойноодо гана автоматтык түрдө жүрөт",
  balances: "Баланстар",
  bankCard: "Банк картасы",
  basketBets: "Себет",
  behind: "га",
  bet: "Коюм",
  betHistory: "Коюм",
  betID: "ID коюмдар",
  betSoldFor: "Kоюм {count}га сатылды",
  betsAreSuspended: "Коюмдарды кабыл алуу токтотулду",
  betsNotAccessForBonusBalance: "Спортко коюмдар бонустук баланстан\nжеткиликсиз!\n",
  bettingHistory: {
    bet: "Коюм",
    coefficient: "Коэффициент",
    dataOfBet: "Коюмдун берилмелери",
    findOutTheScore: "Эсепти билүү",
    numberAndDateOfBet: "Коюмдун номери жана датасы",
    payout: "Төлөп берүү",
    status: "Статус"
  },
  bidAddedToCart: "Коюм себетке кошулду",
  bidDeletedToCart: "Коюм себеттен өчүрүлдү",
  bonus: "Бонус",
  bonusActivated: "Бонус активдештирилди",
  bonusActivation: "Бонусту активдештирүү",
  bonusBalance: "Бонус. баланс",
  bonusBalanceOnly: "Бонустук баланстан ойноо үчүн бонустук оюнду ачыӊыз",
  bonusCondition: "бонустун шарттары",
  bonusNotActivated: "Бонус активдештирилген жок",
  bonusOnFirstDeposit: "Биринчи депозитке 100 %<br/> бонус",
  bonusQuestion: "Куттуктоочу бонусту ала элексизби?",
  bonusSport: {
    block1: {
      li1: "Оlymp.casino сайтына катталыңыз.",
      li2: "Бонусту активдештирүү үчүн, жеке эсебиңиздеги \"Бонустар\" бөлүмүнө өтүңүз жана сунушту жандырыңыз.",
      li3: "Бир төлөм менен 500 KZT/12000 UZS депозитке салыңыз.",
      li4: "Толуктоодон кийин бонус автоматтык түрдө эсептелет жана сиздин купонуңуздун \"Спорт\" бөлүмүндө коюм үчүн жеткиликтүү болот.",
      title: "Өз бонусуңузду кантип алсаңыз болот:"
    },
    block2: {
      li1: "Колдонуучунун бир гана бонуска укугу бар.",
      li2: "Акысыз коюмду спортко гана колдонсо болот. Сиздин купонуңуз коэффициенти эң азында 3 жана максимуму 10ду түзгөн ординардык коюм болушу керек.",
      li3: "Оюнчу өз эсебине утуштуу бөлүктү гана алат.",
      text: "Мисалы: 3 коэффициентине акысыз 500 коюм. Оюнчу эсебине 3*500-500 = 1000 алат.",
      title: "Шарттары жана жоболору:"
    },
    block3: {
      li1: "Акысыз коюмду ойноо боюнча талаптар 7 күндүн ичинде аткарылышы керек, болбосо бонустун жарактуулук мөөнөтү өтүп кетет.",
      li10: "Olymp.casino сунуштун шарттарын өзгөртүүгө, сунушту жокко чыгарууга же жаңылоого, же болбосо катышуучуга алдын ала билдирбестен анын катышуусунан баш тартууга укуктуу.",
      li11: "Olymp.casino катышуучулардын ушул же башка сунушка катышуусун чектөөсү же алардын катышуусунан баш тартуусу мүмкүн.",
      li12: "Бир кардарга, үй-бүлөгө, дарекке, жалпы компьютерге, жалпы IP-дарекке жана бардык окшош каттоо жазууларга, анын ичинде электрондук почта дарегине, банк эсебинин реквизиттерине, кредиттик карта жөнүндө маалыматка жана төлөм тутумунун эсебине бир гана бонус берүүгө жол берилет.",
      li13: "Olymp.casino бул сунушту каалаган учурда өзгөртүү жана жокко чыгаруу укугун өзүнө калтырат.",
      li14: "Бонусту кабыл алуу менен кардар Olymp.casino-нун бонустук шарттарына, ошондой жалпы эрежелерине жана жоболоруна макул болот.",
      li2: "Утушту чыгаруу үчүн сиз 500 KZT / 12 000 UZS өлчөмүндө минималдуу депозит салып, вейджерди х1 аткарууңуз керек.",
      li3: "Жокко чыгаруу же кайтарып берүү аткарылган учурда – коюм жеңилүү катары эсептелет.",
      li4: "Жарым жеңилүү (азиялык фора жана тотал) учурунда – коюм жеңилүү катары эсептелет.",
      li5: "Жарым жеңүү (азиялык фора жана тотал) учурунда – коюмдун суммасын эске албаганда, кадимки коюм катары эсептелет.",
      li6: "Коюм эсептелгенден кийин, акча сиздин балансыңызга түшөт.",
      li7: "Акысыз коюмду жарым-жартылай колдонууга болбойт (б.а. эгер сизде 500гө акысыз коюмуңуз бар болсо, сиз 500гө коюм коюшуңуз керек. Ар башка купондор үчүн 250-250 кабыл алынбайт).",
      li8: "Сунуш башка жарнамалык жана атайын сунуштар менен айкалышта колдонулбайт.",
      li9: "Бир нече каттоо жазууларды колдонууга жол берилбейт жана бир нече каттоо жазуулар колдонулганы аныкталган учурда бул бардык каттоо жазууларды токтотууга алып келет.",
      title: "Башка шарттар:"
    },
    title: "Olymp.Casino-го кошулуу үчүн мыкты убакыт – азыр, анткени биз ар бир жаңы колдонуучуга спортко акысыз коюм сунуштайбыз 500 KZT / 12 000 UZS"
  },
  bonusTimeLeft: "Аракетти аткаруу үчүн убакыт",
  bonusWager: "Бонустун вейджери:",
  bonuses: "Бонустар",
  bookmakerShort: "БК",
  "break": "Тыныгуу",
  bronze: "Коло",
  btn: "Касса",
  byDefault: "Демейки боюнча",
  byDefaultDown: "Алфавит боюнча (A-Z)",
  byDefaultUp: "Алфавит боюнча (Z-A)",
  bySport: "Спорт түрлөрү боюнча",
  cabbage: {
    eight: "-эгерде оюнчу 5 күндүк толук циклди аяктаган болсо.",
    eighteen: "Байге {number}",
    eleven: "Акцияга катышуу менен, сиз автоматтык түрдө бул акцияны өткөргөн онлайн казино тарабынан бектилиген шарттарга макул болосуз.",
    fifteen: "Максаттар жана байгелер",
    five: "Сыйлыктар күнүмдүк прогресс жана күнүмдүк максаттарды аткаруу менен өсөт. Күнүмдүк прогрессти сактап калуу, циклдин кийинки күнүнө өтүү, чоңураак сыйлыктарды алуу үчүн катышуучу күнүмдүк максатты жок дегенде бир жолу аткарышы керек.",
    four: "«Күнүмдүк байгелер» кампаниясы ар бири күнүмдүк максатты 3 жолу аткаруу мүмкүнчүлүгү менен 5 календардык күнгө чейинки циклдерде жүрөт..",
    fourteen: "Ката болгон (жаңылган) учурда бардык утуштар жокко чыгарылат.",
    list: "Эрежелер жана шарттар:",
    nine: "Акцияга катышуу үчүн кошумча депозиттер же төлөмдөр талап кылынбайт.",
    nineteen: "Күнүмдүк максат 1 жолу аткарылды",
    one: "Акча эквивалентиндеги жогорку сорттогу капуста түшүмүн жыйноо мезгили келди!",
    seven: "-эгер оюнчу күндү өткөрүп жиберсе же күнүмдүк максатты жок дегенде бир жолу аткарбаса;",
    seventeen: "Куүнүмдүк максаттар",
    six: "Катышуучунун күнүмдүк сыйлык цикли 2 учурда биринчи күнгө кайтарылат:",
    sixteen: "Циклдеги күн",
    ten: "Акчага ойноо аркылуу гана акцияга катыша аласыз.",
    thirteen: "{company} сыйлыктарды төлөбөстөн белгисиз мөөнөткө каалаган убакта акцияны токтотууга, ошондой эле алдын ала эскертүүсүз эрежелерди өзгөртүүгө укуктуу.",
    three: "Катышуу үчүн Booongo провайдери сунуштаган оюндардын каалаганын ойношуңуз керек. Байге фонду – бир катышуучуга 1160 еврого чейин. Эгерде катышуучу бүткүл кампаниянын (2 толук цикл) бардык мүмкүн болгон күнүмдүк максаттарын аткарган болсо, сумма максималдуу жалпы жеке байге фондусу катары эсептелет. Эң ширелүү сыйлык ар бир циклдин акыркы күнүндө болот!",
    twelve: "Катышуунун шарттары жана эрежелери {company} калоосу боюнча каалаган убакта өзгөртүлүшү мүмкүн.",
    twenty: "Күнүмдүк максат 2 жолу аткарылды",
    twentyFive: "Катышуучуга 1160 еврого чейин",
    twentyFour: "Байге фонду",
    twentyOne: "Күнүмдүк максат 3 жолу аткарылды",
    twentySix: "Күнү жана убактысы",
    two: "Катышуу үчүн Booongo провайдери сунуштаган оюндардын каалаганын ойноп, күнүмдүк максаттарыңызга жетиңиз.."
  },
  cabinet: "Жеке кабинет",
  calculated: "Эсептелген",
  calculationID: "Эсептөө ID",
  canNotChangeCurrency: "Валютаны өзгөртүүгө болбойт",
  canSelectSavedData: "Сакталган маалыматтарды тандасаңыз болот",
  cancel: "Жокко чыгаруу",
  cancelBonus: "Бонусту жокко чыгаруу",
  cancelBonusConfirm: "Сиз чындыгында бонусту жокко чыгаргыӊыз келеби? Жокко чыгарууда бардык бонустук каражаттар нөлгө келтирилет",
  cantEnterTheCode: "Кодду жазуу ишке ашпай жатабы?",
  carriedOut: "Аткарылды",
  cashBackSum: "Заматта Cashback суммасы",
  cashBoxApproveCode: "Тастыктоо коду",
  cashBoxApproveCodeHint: "Код кассирге каражат чыгарууну тастыктоо үчүн керектелет",
  cashBoxDeliveryText: "Сиздин ыӊгайлыгыӊыз үчүн {0}-дан жогору суммага каражат толуктоодо/чыгарууда сизге курьер келиши мүмкүн. Курьерди чакыруу үчүн, бизге телеграм аркылуу жазыӊыз, логин {1}\n",
  cashbackTitle: "Cashback",
  cashboxAddress: "Кассанын дареги",
  casino: "Казино",
  casinoBonus: "Бонус казино",
  casinoLogin: "{name}-логин",
  categoryFromAtoZ: "Адан Яга чейинки категориялар",
  change: "Өзгɵртүү",
  changeData: "Маалыматтарды өзгөртүү",
  changeEmail: "Почтаны өзгөртүү",
  changeMethod: "Ыкманы өзгөртүү",
  changePassword: "Сырсɵздү ɵзгɵртүү",
  changePhone: "Номерди өзгөртүү",
  changeStatusCode: "Коддун статусун ɵзгɵртүү",
  changeTheEmail: "email-ди ɵзгɵртүү",
  changeWallet: "Капчыкты өзгөртүү",
  changingEmail: "E-mail-ди өзгөртүү",
  changingPhone: "Номерди өзгөртүү",
  checkRobotText: "Сиз робот эмес экениңизди тастыктоо үчүн, \"Тастыктайм\" баскычын басыңыз",
  checking: "Текшерүүдө",
  chooseComfortableAddress: "Кирүү үчүн ыңгайлуу даректи тандаңыз",
  chooseDepositViaCryptocurrencyMethod: "«Криптовалюта аркылуу толуктоо» ыкмасын тандаӊыз",
  chooseVariantOrContinueEnter: "Вариантты тандаңыз же жазуунун улантыңыз",
  chooseVerificationMethod: "Код менен чыгарууну тастыктоону өчүрүү ыкмасын тандаңыз",
  clear: "Тазалоо",
  clearFavorites: "Тандалгандарды тазалоо",
  clickCheckoutInHeaderOfSite: "Сайттын башындагы «Касса» баскычын басыӊыз",
  clickHome: "\"Башкы экранга өтүү\" баскычын таптаңыз",
  clickOnTheOddsYouLike: "Жаккан коэффициенттерди басуу менен калкыма терезеден тез коюмдарды жасаӊыз:",
  clickSelectFrontCoin: "Тыйындын маӊдайынан, мисалы, “Tether TRC20” “Тандоо” баскычын басыӊыз",
  clickShare: "Бөлүшүү дегенди басыңыз",
  clickToAttache: "Файлды жүктөө үчүн басыңыз",
  clickTopMenuToBuyCrypto: "Үстүӊкү менюдан  “Крипто сатып алуу” баскычын тандап, “Банк картасынан төлөө” төлөм ыкмасын тандаӊыз. Мин. сумма - 10.40 USD",
  close: "Жабуу",
  code: "Код",
  codeAlreadySendFillIt: "Биз тастыктоо кодун жөнөттүк, аны киргизүү талаасына киргизиңиз",
  codeIsWrong: "Код туура эмес",
  codeSend: "Смс-код бул номерге жөнөтүлгөн",
  codeSendToEmail: "Код почтага жɵнɵтүлдү",
  codeSendToPhone: "Код бул номерге жөнөтүлгөн",
  codeSendToTelegram: "Код Telegram-дагы бот аркылуу жөнөтүлгөн",
  codeVerificationDisabled: "Код менен тастыктоо ɵчүрүлдү",
  codeVerificationEnabled: "Код менен тастыктоо күйгүзүлдү",
  coinSelection: "Тыйынды тандоо",
  comboBoostBonus: {
    button: "Ойноо",
    content_title: "Комбобусту кантип колдонсо болот:",
    good_luck: "Olymp.casino сизге чоң утуштарды каалайт!",
    range_left_title: "Окуялардын саны",
    range_right_title: "Коэфициент",
    step_one: "Кадам 1:",
    step_one_description: "Уткан экспрессиңизди азыртадан чогулта баштаңыз жана жогорулаган коэффициентти кантип алууга көңүл буруңуз.",
    step_three: "Кадам 3:",
    step_three_description: "Сиз тандаган соң, коюмду тандаңыз! Бонус сиздин жыйынтык коэффициентиңизди автоматтык түрдө жогорулатат. Сиз 'Менин сунуштарым' бөлүмүндө өз сунушуңузду текшере аласыз. Ал маркер менен баса белгиленет COMBOBOOST.",
    step_two: "Кадам 2:",
    step_two_description: "Экспрессиңизди чогултууну улантыңыз жана бонустун көбөйүшүн көрүңүз.",
    welcoming_range_title: "Сиздин коэфициентти таануу.",
    welcoming_text: "Olymp.casino бардык жаңы кардарлар үчүн сонун жаңылык бар! Бул иштээрине ынануу үчүн, бул мүмкүнчүлүктү өзүңүз байкап көрүңүз! Биздин бонустун жардамы менен акыркы катышты көбөйтүү үчүн 2 же андан көп окуялардын экспресс коюмун 1.5 жана андан жогору коэффициент менен жасаңыз. Эсиңизде болсун, Экспресс иш-чаралар канчалык көп болсо, бонусуңуз ошончолук көп болот.",
    welcoming_title: "ЭКСПРЕСС көбүрөөк бонус - көбүрөөк окуялар!"
  },
  commission: "Комиссия:",
  competitionAction: "Көрсөтүлгөн оюндардын бирин ойноп, турнирге катышыӊыз",
  competitionMembers: "турнирдин катышуучулары",
  competitionParticipants: "Бул жерде катшыуучулардын тизмеси кɵрсɵтүлɵт",
  competitionWinners: "Бул жерде жеңүүчүлɵрдүн тизмеси кɵрсɵтүлɵт",
  competitions: "Бардык турнирлер",
  competitionsGames: "Турнирдик",
  competitors: "{count} оюндун катышуучусу",
  completeRegistration: "Каттоону аяктоо",
  completeSecuritySettings: "Жеке маалыматтардын жана каражаттардын ырастамасын аяктаңыз",
  completeSignIn: "Авторизацияны аяктоо",
  completed: "Турнир аяктады",
  conductError: "Ката",
  confirm: "Далилдөө",
  confirmData: "Маалыматтарды тастыктоо",
  confirmInformation: "Маалыматты тастыктоо",
  confirmPersonalData: "Мен жеке маалыматтардын анык экенин жана ɵзгɵртүү мүмкүн эместигин тастыктайм",
  confirmPhoneNumber: "Телефон номерин тастыктоо",
  confirmPhoneThroughTelegram: "Telegram тиркемесине кирип, акча каражаттарын коопсуз чыгарып алуу үчүн, телефон номериңизди тастыктаңыз",
  confirmationCode: "Тастыктоо коду",
  confirmationEmail: "Email далилдөө",
  confirmationPhone: "Телефонду далилдөө",
  confirmed: "Далилденди",
  congratulationsTrustWalletCreated: "Куттуктайбыз! Trust Wallet капчыгы түзүлдү!",
  contact: "Кайрылыӊыз",
  continueSecuritySetup: "Коопсуздук жөндөөлөрүнө кайтуу",
  converting: "автоматтык түрдө конвертацияланат",
  copeAddressMemo: "Мемо ийгиликтүү көчүрмөлөндү",
  copeAddressWallet: "Капчыктын дареги ийгиликтүү көчүрмөлөндү",
  copeAddressWalletNew: "Сиздин капчыгыӊыздын дареги ийгиликтүү көчүрмөлөндү",
  copeCode: "Код ийгиликтүү көчүрүлдү",
  copeSumText: "Сумма ийгиликтүү көчүрмөлөндү",
  copy: "Көчүрмөлөө",
  copyAddress: "Даректи көчүрмөлөө",
  copyCode: "Кодду көчүрүп алуу",
  copyTheAddress: "Даректи көчүрмөлөӊүз",
  countries: {
    bangladesh: "Бангладеш",
    kazakhstan: "Казакстан",
    kyrgyzstan: "Кыргызстан",
    russia: "Россия",
    uzbekistan: "Өзбекстан"
  },
  country: "Өлкөнү тандоо",
  countryNotFound: "Өлкө табылган жок, туура жазылганын текшериңиз",
  countrySelect: "Өлкөнү тандоо",
  coupon: "Купон",
  couponContainsDependentOutcomes: "Купондо көз каранды жыйынтыктар бар",
  createWalletInTrustWallet: "Trust Wallet-тен капчык түзүӊүз",
  cryptoMemo: "Мемо",
  cryptoTournament: "Крипто-турнир",
  cryptoWallerSuccessChanged: "Капчыктын дареги ийгиликтүү ɵзгɵртүлдү",
  cryptoWallet: "Крипто капчык",
  cryptocurrency: "Криптовалюта",
  currency: "Валюта",
  current: "Учурдагы",
  currentBalanceIsLessThanTheWithdrawalAmount: "Бардык төлөм ыкмалары жеткиликтүү, учурдагы баланс транзакцияны аткаруу үчүн минималдуу  суммадан аз",
  currentRates: "Учурдагы коюмдар",
  customerSupport: "колдоо кызматы ",
  customizeDisplayedCoins: "Чагылдырылып жаткан тыйындарды ырастоо үчүн үстүӊкү оӊ бурчтагы жылгычты басыӊыз, токендерди кошуу баракчасындагы издөө сабына Doge жазыӊыз. Doge тыйынын тыйындын маӊдайындагы жылгычты басуу менен активдештириӊиз",
  cyrillicInPasswordNotAvailable: "Сыр сөздө кириллицаны колдонууга жол берилебейт",
  data: "Дата",
  dataNotSpecified: "Маалыматтар көрсөтүлгөн эмес",
  date: "Дата",
  dateFrom: "кийинки дата",
  dateOfTransaction: "Транзакциянын датасы",
  dateTo: "чейинки дата",
  deadline: "Аяктаганга калды:",
  december: "декабрь",
  decline: "Четке кагылды",
  demo: "Демо",
  deposit: "Депозит",
  depositAccount: "Эсепти толуктоо",
  depositBK: "БКдан толтуруу",
  depositBonus: "толуктоодо {bonus} бонус",
  depositForBonus: "Бонус алуу үчүн, {sum}-дан жогору суммага депозит салыӊыз",
  depositNoun: "Толуктоо",
  depositRequired: "<span class='bonus-item__sum'>{sum}</span> жогору депозит салуу зарыл",
  description: "Баяндамасы",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Онлайн слоттор ➔  акчага, ✓акысыз жана ✓катталуусуз ✓ ойноңуз. {company}казино расмий ɵндүрүүчүлɵрдүн ✓кɵп бонустары бар ✓ жана ар кандай тематикадагы ✓акысыз ✓популярдуу ✓заманбап оюн автоматтарын сунуштайт. "
    }
  },
  details: "Тагыраак",
  docsWasApproved: "Документтер ийгиликтүү текшерилди",
  docsWasDeclined: "Документтер текшерүүдөн өткөн жок",
  documentAttacheMessage: "Биз аларды 24 сааттын ичинде текшеребиз. Андан кийин, бардык төлөм кымалары Сиз үчүн жеткиликтүү болуп калат.",
  documentAttacheSuccess: "Сиздин документтериңиз ийгиликтүү жөнөтүлдү.",
  documentDeleteSuccess: "Документтер ийгиликтүү өчүрүлдү",
  documentNumber: "Документтин номери",
  documentUpload: "Документтерди жүктөө",
  done: "Даяр!",
  doneThresholdConditions: "Депозитти кайра ойноп утуп алуу шарттары аткарылды",
  download: "Жүктөө",
  downloadApp: "Тиркемени жүктөө",
  downloadOlimpApp: "Олимп тиркемесин жүктөө",
  download_app: "Олимп тиркемесин жүктөө",
  dropswins: {
    eight: "Кокус учурларда 9000€ суммасындагы акчалай байгелер ойнотулат. Утуп алыш үчүн ойно!",
    eighteen: "Эрежелер жана шарттар",
    eleven: "Ар аптылк турнирдин байгелеринин таблицасы (кадимки апталар)",
    fifteen: "Күнүмдүк байгелердин таблицасы",
    five: "АР КҮН САЙЫН",
    four: "ТУРНИР",
    fourteen: "Ар аптылк турнирдин байгелеринин таблицасы (кадимки апталар)",
    nine: "4 х 62 000€ ар апталык турнир",
    nineteen: "1. Бул Pragmatic Play TM тармактык кампаниясы. Бул кампания 11.02.2021ден 17.11.2021ге чейинки мезгилде ɵткɵрүлɵт CET ( 01:01 11.02.2021ден 00:59 18.11.2021ге чейин EET)<br>2. Кампания 10 этапта ɵткɵрүлɵт жана алардын ар бири 4 аптага созулат.<br>3. Акциянын жалпы байге фонду 4 000 000 € түзɵт, ал 40 x 62 000 € ар апталык турнирлерден жана 40 x 63 000 € ар апталык байгелерди ойнотуулардан турат.<br>4. Тɵмɵндɵ бул акциянын 7-этабынын шарттары келтирилген. Турнирдин механикасы этабына жараша ɵзгɵрɵрүнɵ кɵңүл буруңуз.<br>5. Тармактык кампаниянын каалаган Турнирлерине же Байгелерди ойнотуусуна катышуу үчүн, оюнчулар катышкан оюндардын каалаганын ачып, катышуусун тастыктоосу/шарттарына макул болуусу керек.<br>6. Турнирлердин жана байгелерди ойнотуунун тɵрт (4) аптасы тɵмɵнкүдɵй ɵткɵрүлɵт:<br>Апта 27: 11.08.2021 саат 20:01де- 18.08.2021 саат 19:59да EET<br>Апта 28: 18.08.2021 саат 20:01де- 25.08.2021 саат 19:59да EET<br>7. Квалификациялык оюндар:<br>Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™\"",
    one: "Pragmatic Play-дин Drops & Wins тармактык турнирине катышыңыз, бул жерден ар бир адам жеңүүчү боло алат!",
    seven: "Жалгыз айлантууда эң жогорку утушка ээ болуп, лидерлер таблицасынын чокусуна чык. ",
    seventeen: "Бул турнирде турнирге катышуу коюмдун көлөмүнө карабастан, бардык оюнчулар үчүн адилеттүү болгудай утуш кɵбɵйтүүчүсүнүн эсептеген механизм колдонулат. Мисалы, эгер сиз 2€ коюм коюп, 10€ утуп алсаңыз, анда сиздин утушуңуздун кɵбɵйтүүчүсү беш болот. Бул учурда, сиз беш упай аласыз. Жалгыз айлантууда эң жогорку утуш менен лидерлердин Топ-1200үнɵ кириңиз.",
    six: "Оюндарды тиркемеден ачып, турнирге кошулуп, ойноп башта (минималдуу коюм 0.5 евро).",
    sixteen: "Турнирге жана байгелерди ойнотууга автоматтык түрдɵ катышуу үчүн кампанияга болгону бир жолу кошулууңуз керек.",
    ten: "4 х 63 000€ ар апталык байгелерди ойнотуу",
    thirteen: "Сыйлык",
    three: "ОЙНОО",
    twelve: "Орун",
    twenty: "Ар апталык турнирлер",
    twentyfour: "Заматтагы cashback",
    twentyone: "1. Лидерлердин таблицасы упайларга ылайык калыптанат, ал эми упайлар коюмдун суммасын эске алуу менен турнирге катышкан каалаган оюндан алынган бир спин үчүн эң чоң утуштун негизинде берилет.<br>2. Лидерлердин таблицасы реалдуу убакыт режиминде жаңыланат, жана оюнчулар лидерлердин таблицасын турнирге катшыкан каалаган оюн учурунда каалаган убакта кɵрɵ алышат.<br>3. Эгер (2) же андан кɵп оюнчу турнирди лидерлердин таблицасындагы бир эле позицияда аяктаса, жогорураак орун мындай упайлардын санын биринчи алган оюнчуга берилет.<br>4. Байгелер оюнчуларга белгиленген сумма түрүндɵ тɵлɵнɵт.<br>6. Ар апталык байге фонду жалпы суммасы 62 000 € барабар 1200 акчалай байгени камтыйт.<br>7. ОРУН – АР АПТАЛЫК БАЙГЕЛЕР<br>1. €10,000<br>2. €5,000<br>3. €2,000<br>4-10. €1,000<br>11-20. €500<br>21-50. €200<br>51-100. €100<br>101-300. €50<br>301-600. €20<br>601-1200. €10\n",
    twentythree: "1. Акциянын ар аптасын ичинде жети (7) ар апталык байгелерди ойнотуу жүргүзүлɵт.\n<br>2. Ар бир акциянын жүрүшүндɵ шарттарга ылайык келген бир (1) спин, байге фондунан бир (1) байге алып келиши мүмкүн.<br>3. Байгелер кокустук негизинде ойнотулат. Эрежелер жана байгелердин таблицасы урнирге катышкан оюндарда жеткиликтүү. Байгелердин таблицасы учурдагы абалды жана калган байгелердин санын кɵрсɵтүү менен реалдуу убакыт режиминде жаңыланып турат.<br>4. Байгелер турнирге катышкан оюндардын ар бириндеги «Байгелер» салмасында кɵрсɵтүлгɵндɵй тɵлɵнɵт.<br>5. Байгелер оюнчуларга белгиленген сумма түрүндɵ тɵлɵнɵт.<br>6. Байгелерди ойнотууга катышуу үчүн реалдуу акчага минималдуу коюмду коюу зарыл: турнирге катышкан оюнда (-дарда) 0,50 €. Бир оюнчу ар бир күндүн ичинде бир нече байге ута алат.<br>7. Байгелерди ойнотуу күн сайын (i) 00:59дɵ EEST/EET же (ii) байгелердин баарын ыйгаргандан кийин (кайсынысы биринчи болгонуна жараша) аяктайт.<br>8. Эгер конкреттүү ойнотуунун байге фонду толук бɵлүштүрүлбɵсɵ, анда бардык ашыкча каражаттар PragmaticPlay™ ыктыяры боюнча кийинки этаптын байге фондуна которулат.<br>9. Ар апталык байге фонду жалпысынан 63,000 €, ал эми байге фонду 500 акчалай байгени жана 9,000 € жалпы суммасына акысыз раунддарды камтыйт.<br>10. Саны – Ар күндүк байгелер<br>1 X€1,000\n<br>2 X €500<br>5 X €100<br>12 X €50<br>110 X €20<br>370 X €10<br>11. Жеңүүчүлɵр ɵз байгелерин акчалай түрдɵ алат. Акчалай байгелер автоматтык түрдɵ алардын {baseLink}казинодогу оюн эсептерине турнир аяктагандан кийин которулат.<br>12. {baseLink}каалаган учурда акциянын шарттарын ɵзгɵртүүгɵ же жокко чыгаруу укуктуу.<br>13.{baseLink} жалпы эрежелер жана шарттар иштейт.\n",
    twentytwo: "Ар апталык байгелерди ойнотуу",
    two: "500 000€ ɵлчɵмүндɵгү байге фонду этаптар арасында – аптасына 125 000€ боолуп бɵлүнгɵн! Катышуу үчүн, болгону тɵмɵнкү кадамдарды кайтала!"
  },
  email: "Email",
  emailNeedValid: "Почтага текшерүү коду келет",
  emailSuccessfullyApproved: "E-mail ийгиликтүү тастыкталды",
  emptyGames: "Биз сиз үчүн мындай оюндарды таба алган жокпуз",
  emptyPromoPage: "Бул жерде жүрүп жаткан акциялар көрсөтүлөт",
  ended: "Аяктады",
  engineeringWorks: "5 мүнөттөн кийин сайтта техникалык иштер жүргүзүлөт",
  english: "Англисче",
  enter: "Вступить\n",
  enterCode: "Кодду жазыӊыз",
  enterCodeFromEmail: "Email-деги кодду жазыңыз",
  enterCorrectPhoneNumber: "Туура телефон номерин жазыңыз\n\n",
  enterCryptoWallet: "Криптокапчыкты жазуу",
  enterCryptoWalletOnProfilePage: "Утушту алуу үчүн, жеке кабинетиңизден Doge криптокапчыгын жазыңыз",
  enterGameName: "Оюндун атын киргизиңиз",
  enterGameNameOrProvider: "Оюндун же провайдердин атын киргизиңиз",
  enterMoreCharacters: "Сураныч, көбүрөөк символдорду киргизиңиз!",
  enterPromoCode: "Промокодду киргизиңиз",
  enterSMS: "SMSтен кодду киргизиңиз",
  enterSixDigitCode: "Тиркемедеги 6 орундуу кодду жазыңыз",
  enterValidEmail: "Туура почтаны жазыңыз",
  enterWalletAddress: "Турнирдин утушун которуу үчүн, азыр же кийинчерээк Doge криптокапчыгынын дарегин көрсөтүңүз. ",
  enterYourBankCardDetails: "Банк картасынын маалыматтарын жазыӊыз, төлөм системасынын шарттары менен макул болуп, “Төлөө” баскычын басыӊыз",
  entrance: "Кирүү",
  err404subtitle: "Сени башкы баракчада күтөбүз!",
  err404title: "Тилекке каршы, эч нерсе табылган жок…",
  error: "Ката",
  errorPasswordField: "Сырсɵз сандарды, баштамгаларды жана саптамгаларды камтышы керек",
  errorPaymentDataInitialization: "Төлөм тутумун инициалдыштырууда ката кетти",
  errorPaymentUrlInitialization: "Төлөмдү инициалдаштырууда ката кетти",
  errorWhileSendingCode: "Код менен билдирүү жөнөтүү ишке ашкан жок, сураныч,  дагы бир жолу сурап көрүңүз",
  errorsWhileValidate: "Форманы валидациялоодогу каталар",
  euro_slot: {
    description: "Euro Slots 2024 {platform} гана онлайн ойноо - мыкты расмий оюн слоттору. Онлайн казинолордо бекер жана акча үчүн ойноңуз.",
    end: "Турнир аяктады",
    "final": "Финалга чык",
    inProgress: "Матч жүрүп жатат",
    mathPrize: "Матчтын байге фонду:",
    onWallet: "эсепке",
    prize: "Жалпы байге фонду:",
    "prize-short": "БАЙГЕ",
    prizeFond: {
      "1\/2": "1/2 финалдын <p>байге фонду:</p>",
      "1\/4": "1/4 финалдын <p>байге фонду:</p>",
      "1\/8": "1/8 финалдын <p>байге фонду:</p>",
      "final": "Финалдын <p>байге фонду:</p>"
    },
    rules: {
      "1": "Акция 13.06.2024 00-00 GMT +5 тарта 14.07.2024 00-00 GMT +5 чейин жүргүзүлөт",
      "2": "Турнирдин жалпы байге фонду: {sum}",
      "3": "Ырааттама боюнча турнирдик торчо боюнча жылган слоттордун арасында таймаш өткөрүлөт",
      "4": "Тигил же бул акциялык оюндун жеӊишине эӊ көп салым кошкон колдонуучулар байге фондун өз ара бөлүшүп алышат",
      "5": "1/8 баскычындагы жуптар үчүн даталар ({sum}):",
      "6": "1/4 баскычындагы жуптар үчүн даталар ({sum}):",
      "7": "1/2 баскычындагы жуптар үчүн даталар ({sum}):",
      "8": "Финалдын даталары ({sum}):",
      "9": "Байгелерди которуу оюн эсебине 24 сааттын ичинде автоматтык түрдө жүргүзүлөт"
    },
    stage1: "<span>Катталып,</span> «КАТЫШУУ» баскычын бас.",
    stage2: "<span>Катышкан оюндардын ичинен каалаганына коюп,</span> упайларды топто.",
    stage3: "<span>Топ оюнчу</span> жалпы байге фондун бөлүп алат",
    stages: {
      "1\/2": "1/2 финал",
      "1\/4": "1/4 финал",
      "1\/8": "1/8 финал",
      "final": "финал"
    },
    stagesAtStart: {
      "1\/2": "Финалдын башталышына чейин:",
      "1\/4": "1/2 финалдын башталышына чейин:",
      "1\/8": "1/4 финалдын башталышына чейин:",
      "final": "Финал",
      pre: "1/8 финалдын башталышына чейин:"
    },
    start: "Кантип катышса болот",
    table: "Турнирдик таблица",
    title: "Euro Slots 2024 Турнири  - {platformSite} онлайн казиносунда слотторду ойноңуз",
    winners: "Турнирдин жеӊүүчүлөрү"
  },
  events: "Окуялар",
  exchangeRateInTenge: "Тенге менен валюта курсу",
  exit: "Чыгуу",
  express: "Экспресс",
  expressCoef: "Экспресстин коэффициенти",
  expressSystem: "Экспресстердин системасы",
  failed: "Аракет жасалган жок",
  fastBet: "Тез коюм",
  fastbetDetailedDescription: "Тез коюм болгону эки баскыч менен бирден жасалуучу коюмдарды жасоого мүмкүндүк берет. Акыркы коюлган коюмдун суммасын эстеп калуу коюмдарды кабыл алуу процессин кошумча тездетет.",
  fastbetSetting: "Тез коюм ырастамалары",
  fastbetSum: "Тез коюмдун суммасы",
  favorite: {
    added: "Оюн тандалгандарга кошулду",
    removed: "Оюн тандалгандардан өчүрүлдү"
  },
  favorites: "Тандалган",
  february: "февраль",
  fieldRequire: "Толтурууга милдеттүү талаа",
  fileAttached: "Файл тиркелген",
  fileNotAttached: "Файл тиркелген эмес",
  fillInformation: "Маалыматты толтуруу ",
  fillProfileInfoForWithdraw: "Сураныч, акча чыгаруу үчүн жеке маалыматтарыңызды толтуруңуз.",
  fillRequiredInfoBelow: "Сураныч, тɵмɵндɵгү зарыл болгон маалыматты толтуруңуз",
  filter: "Фильтр",
  filterByDate: "Датасы боюнча фильтр",
  filtersText: {
    inTheNextSixHours: "жакынкы 6 саатта",
    inTheNextTwentyFourHours: "жакынкы суткада",
    inTheNextTwoHours: "жакынкы 2 саатта",
    nextThreeDays: "жакынкы 3 суткада",
    nextTwelveHours: "жакынкы 12 сатта",
    nextWeek: "жакынкы аптада",
    today: "Бүгүн",
    tomorrow: "Эртең",
    whenever: "каалаган убакта"
  },
  findOutAddressOfDogeWallet: "Doge капчыгынын дарегин билип алыӊыз",
  fine: "Макул",
  firstAuthMessage: "Телефон номерине логин жана сыр сөзү менен СМС жөнөтүлгөн. Эсепти толуктап, биринчи утуштарга жөнөңүз",
  firstDeposit: "Биринчи депозитке!",
  forCorrectGamePushRefresh: "Оюнду туура көрсөтүү үчүн, жаңылоо баскычын басыңыз",
  forEndCompetition: "Турнирдин аягына чейин",
  forMoreInformation: "Кошумча маалымат үчүн",
  forStartCompetition: "Турнирдин башталышына чейин",
  forgotPassword: "Сырсɵздү унутуп калдыңызбы?",
  fraud: "AML саясат",
  freeBetsButton: "Таанышып чыгуу",
  freeBetsCount: "Жеткиликтүү фрибеттер:",
  freeBetsStepFour: "Коюм коюңуз",
  freeBetsStepOne: "«Спорт» бөлүмүн ачыңыз",
  freeBetsStepThree: "Окуяны тандаңыз",
  freeBetsStepTwo: "Купондо «Фрибетти» активдештириӊиз",
  freeBetsTitle: "Спорт үчүн \"Фрибет\"",
  freeSpinsInGame: "Free Spins оюнда",
  freespin: "Фриспин",
  freespinsAvailable: "Жеткиликтүү фриспиндер:",
  from: "{date}-дан баштап",
  fromAnySum: "Каалаган суммадан баштап",
  fromNumber: "баштап",
  fromSmth: "{value}дон баштап",
  fulfillConditionsForWithdrawal: "Каражаттарды чыгаруу үчүн бардык шарттарды аткарыӊыз.",
  fund: "Байге фонду",
  future: "Келечектеги",
  game: "Оюн",
  gameDescTemplate: "{gameName} оюн автоматы {providerName} белгилүү иштеп чыгуучунун онлайн слоту болуп саналат. {gameName} оюн автоматын бекер ойноңуз же чыныгы акчага ойноо үчүн катталыңыз",
  gameForMoneyOnlyForAuthUser: "Акча үчүн оюн катталган гана колдонуучулар үчүн жеткиликтүү",
  gameInOtherTab: "Оюн башка өтмөктө ачык",
  gameNotAvailableBonus: "Оюн бонустун шарттарынан улам жеткиликсиз",
  gameNotAvailableGeoRestriction: "Оюн сиздин аймакта жеткиликсиз",
  gameNotFound: "Оюн табылган жок",
  gameTitleTemplate: "{gameName} оюн автоматы. {company} онлайн казиносунда бекер ойноо",
  gameUnavailable: "Оюн убактылуу жеткиликсиз",
  game_categories: "Оюндардын категориясы",
  games: {
    tryOther: "Башка оюндарды ойноп көрүңүз"
  },
  gamesNotFound: "Оюндар табылган жок",
  geoRestrictionDesc: "Тилекке каршы, оюн сиздин аймакта жеткиликсиз.",
  geoRestrictionDescLine2: "Каталогдон башка оюнду тандоону сунуштайбыз",
  get: "Алуу",
  getBonus: "Бонусту алуу",
  getBonusByPromoCode: "Промокод боюнча бонус алыңыз",
  getGainFromFreeSpins: "Фриспиндерден утуш алуу",
  getNewCode: "Жаңы кодду алуу",
  getSMS: "SMS код алуу",
  go: "Өтүү",
  goBack: "Артка кайтуу",
  goToGame: "Оюнга өтүү",
  goToGames: "Оюндарга өтүү",
  goToHome: "Башкы менюга кайтуу",
  goToOlimpCasinoAndPlayFavoriteGames: "Olimp Casino-го өтүп, сүйүктүү оюндарыңызды ойноңуз:)",
  goToVolet: "volet.com (advcash) сайтына өтүү",
  goToWallet: "Капчыкка өтүү",
  goesNow: "Азыр жүрүп жатат",
  gold: "Алтын",
  guarantee: {
    five: "Оюндан көз карандысыз баш тартуу. Эгер оюнга болгон каалоону азайтуу үчүн, сиз биздин казинонун колдоо кызматына баракчаңызды бөгөттөө өтүнүчү менен кайрылсаңыз, сиздин өтүнүчүңүз аткарылат. Оюнчунун профилин биротоло жок кылуу мүмкүнчүлүгү бар. Башка учурда, оюнчунун өтүнүчү боюнча, ал бир нече убакыт өткөндөн кийин калыбына келтирилиши мүмкүн.",
    four: "Оюнга жеке мүмкүнчүлүктү чектөөнү каалаган оюнчулар үчүн төмөнкү варианттар иштелип чыккан:",
    one: "Жоопту оюн",
    seven: "Чектелген жеткиликтүүлүк. Эгерде сиз өзүңүздү кумар оюндарын же жарнамаларды сунуштаган ар кандай сайттардан коргогуңуз келсе, анда атайын программалык камсыздоону колдонушуңуз керек. Ал чыпкалоо системаларын түзөт жана кумар оюндарына көз карандылыкка жакын колдонуучулар үчүн коопсуз онлайн тажрыйбасын камсыз кылат. Мындан тышкары, программалык камсыздоону балдардын керексиз ресурстарга кирүүсүнө жол бербөө үчүн колдонсо болот. Мындай программалык камсыздоонун мисалдары: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "Адистештирилген жардам. Кумар оюндарына көз каранды болгон учурда, оюнчулар квалификациялуу адистердин жардамына кайрыла алышат. Сизге жардам бере алат: Gamblers Anonymous (www.gamblersanonymous.org.uk) - көз каранды кумарчыларга жардам көрсөтүүчү жашыруун оюнчулардын эл аралык коому; GamCare (www.gamcare.org. uk) – англис тилдүү уюм, ал кумарчыларга көз карандылыктан арылууга жардам берет; Gambling Therapy (www.gamblingtherapy.org) – жалпы оору менен күрөшүү үчүн эксперттик колдоо көрсөткөн Улуу Британиядагы уюм.",
    three: "Эгер сиз кумар оюндарына бир аз көз каранды болсоңуз, биринчи кезекте кумар оюндары сиз үчүн эмне экенин аныктаңыз. Эгер оюн жашоодогу кыйынчылыктардан кутулуу аракети болсо, ал сиздин бош убактыңыздын дээрлик баарын алып, жумушуңузга тоскоол болуп жатса, анда бул биринчи коңгуроо. Эгер сиз ойноо үчүн карызга акча алып жатсаңыз жана ансыз күнүңүздү элестете албасаңыз, бул сизге кескин өзгөрүү керек экендигинин ишенимдүү белгиси.",
    two: "{titlePure} сайтында ойногон колдонуучулардын алдында белгилүү бир жоопкерчиликтерге ээ. Казино администрациясы оюнчуларга кумар оюндарына көз карандылыктын пайда болушу менен күрөшүүгө жардам берүүгө даяр. Оюндун маңызы - позитивдүү эмоцияларды жеткирүү жана эс алуу. Албетте, каталар болушу мүмкүн, бирок бул эч кандай каржылык себеп болбошу керек"
  },
  hasMinimalDeposit: "Минималдуу депозит салынды",
  haveActivatedFastbetMode: "Сиз тез коюм режимин активдештирдиңиз. Эрежелер менен таанышуу үчүн, сураныч, бул жерди басыңыз",
  haveNotEmailContactUs: "Эгер сизге кат келбесе, сураныч, «Спам» жана «Промоакциялар» папкаларын текшериңиз же {0} менен байланышыңыз",
  haveNotPhoneContactUs: "Эгер сиздин телефон номериңизге смс келбесе, {0} менен байланышыңыз",
  here: "Бул жерде",
  hiddenConditions: "Жашыруун шарттар",
  hide: "Жашыруу",
  hideBonusCondition: "Бонустук шарттарды жашыруу",
  hideDetails: "Кеңири маалыматты жашыруу",
  history: "Тарых",
  historyBets: "Коюмдар тарыхы",
  historyPayments: "Транзакциядардын тарыхы",
  historyTransactions: "Транзакциялардын тарыхы",
  hotGame: "Ысык",
  hotGames: "Активдештирилген",
  hotToBuyCryptoCurrency: "Криптовалютаны кантип сатып алса болот?",
  howCanBuyCryptocurrency: "Криптовалютаны кантип сатып алсам болот?",
  howCreateCryptoWallet: "Криптокапчыкты кантип ачса болот?",
  howCreateWallet: "Как создать кошелёк?\n",
  howToCreateCryptoWallet: "Криптокапчыкты кантип ачса болот?",
  howToFindOutWalletNumber: "Капчыктын номерин кантип билсе болот?",
  howToInstallApp: "Тиркемени кантип орнотуу керек?",
  howToViewMyCryptoWalletInOlimp: "Олимптеги крипто-капчыгымды кантип көрсөм болот?",
  howTopUp: "Кантип толуктоо керек",
  howTransferCrypt: "Криптовалютаны кантип которсо болот",
  howTransferCryptStep1: "Капчыкка же биржага кирүү",
  howTransferCryptStep2: "Найти выбранную монету {currency}\n",
  howTransferCryptStep3: "Биздин капчыгыбыздын дарегин коюу",
  howTransferCryptStep4: "Суммасын көрсөтүп, жөнөтүү",
  iPaid: "Мен толуктадым",
  idWasCopied: "Сиз транзакция id-син көчүрмөлөп алдыӊыз",
  inSettings: "ырастамаларда",
  information: "Маалымат",
  informationConfirmWithdraw: "Акча чыгаруунун коопсуздугу үчүн маалыматтарыңызды текшериңиз. Электрондук почтанын дарегин же телефон номерин өзгөтүү үчүн менен байланышыңыз",
  informationConfirmWithdrawSupport: "колдоо кызматы ",
  informationForUpdateProfileData: "Байланыш маалыматын жаңыртуу үчүн колдоо кызматына кайрылуу зарыл",
  installApp: "тиркемени орнотуу үчүн {0}",
  installTrustWalletApp: "Trust Wallet тиркемесин орнотуӊуз",
  instant: "Тез",
  instantCash: "Cashback",
  instantCashback: "Заматтагы cashback",
  instantWithdrawal: "Заматтагы чыгаруу",
  instantly: "Дароо",
  insufficientFundsAvailable: "Каражат жетишсиз. Жеткиликтүү:",
  invalidCryptoWallet: "Капчыктын дареги туура эмес",
  invalidDateFormat: "Датанын форматы туура эмес ",
  invalidDateInterval: "Тандалган интервал туура эмес",
  invalidStartDate: "Баштоо датасы туура эмес",
  iosWebAppInstruction: "iOS нускамалары",
  jackpot: "Джекпот",
  jackpotGame: "Джекпоту менен",
  january: "январь",
  july: "июль",
  june: "июнь",
  kazakh: "Казакча",
  kycPolicy: "KYC саясаты",
  latestGames: "Акыркы оюндар",
  leftCount: "{count} калды",
  leftDeposit: "{sum} толуктоо керек",
  licenseCuracao: "Содержимое веб-сайта принадлежит и управляется Perantia N.V. (<a href='https://olimp.com' target='_blank'>olimp.com</a>) в качестве держателя лицензии (лицензия Кюрасао № 365/JAZ). Все права защищены и охраняются законом.",
  lineOn: "{date}га карата линия",
  linkIsReady: "Шилтеме даяр",
  liveCashBackDesc: "{company} биздин VIP кардарларыбызга гана жеткиликтүү болгон эксклюзивдүү бонусту сунуштайт! \"LIVE Казино\" категориясындагы оюндарга коюмдарды коюңуз жана утулган коюмдардын суммасына жараша эсебиңизге Cashback алыңыз! - кыскача баяндоо. Азырынча толук баяндоо үчүн өзүнчө барак ачпайбыз.",
  liveCashback: "Live cashback",
  liveCashbackHistory: "Live cashback тарыхы",
  live_casino: "LIVE Казино",
  loading: "Жүктөө",
  loadingLanguage: "Тилди жүктөө",
  lobby: "Башкы",
  login: "Логин",
  loginCopied: "Сиздин логиниӊиз көчүрмөлөнгөн",
  loginErr: "{name} логини тамгаларды камтыбайт!",
  loginTelegram: "Telegram-дын жардамы менен кирүү",
  logoutFromSystem: "Системадан чыгуу",
  lose: "Жеңилип калуу",
  losers: "Утулган",
  lottery: "Лотерея",
  mainPage: "Башкы бет",
  makeABet: "Коюм коюу",
  makeBet: "Коюм коюу",
  makeDeposit: "Депозит салуу",
  march: "март",
  matchClosed: "Матч жабык",
  matchEnded: "Матч аяктады",
  matchNotFound: "Матч табылган жок",
  matchPlanned: "Матч пландалып жатат",
  matches: "Матчтар",
  maxBet: "Максималдуу коюм ",
  maxForExpress: "Экспресс үчүн максимум",
  maxLength: "Талаанын максималдуу узундугу {length}",
  maxOutput: "Чыгаруунун минималдуу суммасы",
  maxPay: "Төлөмдүн максималдуу суммасы",
  maxSum: "Макс. сумма",
  maxValue: "Максималдуу маани {value}",
  maxValueShort: "Макс. {value}",
  maxWithdrawSum: "Чыгаруунун максималдуу суммасы",
  maximumPayment: "Төлөмдүн максималдуу суммасы",
  may: "май",
  messageSMS: "СМСтен кодду киргизиңиз",
  messages: "Билдирүү",
  middleName: "Атасынын аты",
  minBet: "Минималдуу коюм\n\n",
  minDepositForBonus: "кадамды аяктоо үчүн, {sum} суммасынан кем эмес депозит салыңыз",
  minLength: "Талаанын минималдуу узундугу {length}",
  minLengthPassword: "Сыр сөздүн минималдуу узундугу {min} белги\n\n",
  minOutput: "Эсепке киргизүү мөөнөтү",
  minPay: "Төлөмдүн минималдуу суммасы",
  minSum: "Мин. сумма",
  minValue: "Минималдуу маани {value}",
  minValueShort: "Мин. {value}",
  minimalDeposit: "Минималдуу депозит",
  minimalLengthOfCode: "Коддун минималдуу узундугу {num} символ\n\n",
  minimalSum: "Минималдуу сумма",
  minimumPayment: "Төлөмдүн минималдуу суммасы",
  minimumTransfer: "Эсепке которуунун минималдуу суммасы:",
  modal_telegram: "Биздин каналдан сен активдүү бонустарды, ар апталык утуштарды жана көптөгөн башка нерселерди таба аласыӊ, ал эми бот менен сайтка болгон жеткилигиӊди эч убакта жоготуп албайсыӊ!",
  more: "Дагы",
  moveToBonus: "Бонуска өтүү",
  moveToMessages: "Билдирүүлөргө өтүү",
  myBalances: "Менин баланстарым",
  myBonuses: "Менин бонустарым",
  name: "Аталышы",
  namePerson: "Аты",
  nameTheCheckout: "Кассирге капчыктын дарегин атаңыз",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGames",
    fantasy: "Fantasy",
    fast: "Тез",
    jetx: "JetX",
    line: "Сызык",
    live: "Live",
    liveGames: "LiveGames37",
    lottery: "Лотерея",
    online: "Live Казино",
    slot: "Слоттор",
    sportGames: "Sport games",
    table: "Үстөл",
    turboGames: "Turbo games",
    vSport: "V-Sport",
    virtualGames: "Виртуалдык",
    worldcup: "ДЧ-2022"
  },
  navLinks: {
    bonuses: "Бонустар",
    home: "Башкы",
    homeCasino: "Казино",
    posts: "Билдирүү",
    profile: "Профиль",
    promo: "Акциялар",
    sport: "Спорт",
    tournament: "Турнирлер"
  },
  needConfirmProfileInformation: "Бонусту активдештирүү үчүн профилден ɵзүңүз жɵнүндɵ балансты тастыктаңыз",
  needDeposit: "Депозит салуу зарыл",
  needSettingsSecurity: "Коопсуздук ырастамаларынан өтүү зарыл",
  needToExecuteConditions: "Шарттарды аткаруу зарыл",
  never: "Эч качан",
  "new": "Жаңы",
  new2: "Жаңы",
  newBonusAvailable: "Сизге жаңы бонус бар",
  newGame: "Жаңы",
  newMessage: "Жаңы билдирүү",
  newMessages: "Жаңы билдирүүлөр",
  newOne: "Жаңы",
  newVersionReloadPage: "Сайттын версиясы жаңырды, туура иштеши үчүн баракты жаңыртыңыз",
  newYearPromocodes2025: {
    NY25DAY1: "Santa's​ Gift​ ​оюнунда​ 50​ FS",
    NY25DAY10: "Спортко​•​фрибет!",
    NY25DAY11: "Santa's​ Great ​Gifts​ оюнунда​ 50​ ​FS",
    NY25DAY12: "Royal​ Xmass​ 2​ ​оюнунда​ 75​ FS",
    NY25DAY13: "Депозитке​•​75%​•​жана​•​75​•​FS​•​белекке!",
    NY25DAY14: "Santa's​ Xmas​ Rush​ оюнунда​ 100​ FS",
    NY25DAY2: "Спортко​•​фрибет!",
    NY25DAY3: "Депозитке​•​50%​•​жана​•​50​•​FS​•​белекке!",
    NY25DAY4: "Buffalo​ Power:​ Christmas​ оюнунда​ 75​ FS",
    NY25DAY5: "Депозитке​•​75%​•​жана​•​75​•​FS​•​белекке!",
    NY25DAY6: "Royal​ ​Xmass ​оюнунда​ 75​ FS",
    NY25DAY7: "Депозитке​•​100%​•​жана​•​100​•​FS​•​белекке!",
    NY25DAY8: "Sugar​ Rush​ Xmas ​оюнунда​ 100​ ​FS",
    NY25DAY9: "Депозитке​•​50%​•​жана​•​50​•​FS​•​белекке!"
  },
  next: "Андан ары",
  nextGames: "Дагы көрсөтүү",
  no: "Жок",
  noAccount: "Аккаунт жок",
  noBetsInHistory: "Сиздин тарыхыӊызда коюмдар жок",
  noConnectionTryAlready: "Интернетке туташуу жок. Интернетке кошулуп, дагы бир жолу аракет кылып көрүӊүз.",
  noDeposit: "Депозитсиз",
  noFavoritesYet: "Тандалгандарда азырынча эч нерсе жок",
  noMatchSelected: "Бир дагы матч тандалган эмес же сызыкта окуялар жок!",
  noResults: {
    bets: "Сиздин коюмдар бул жерде көрсөтүлөт",
    bonuses: "Бул жерде жеткиликтүү бонустар көрсөтүлөт",
    competitions: {
      active: "Бул жерде активдүү турнирлер көрсөтүлөт",
      all: "Бул жерде бардык турнирлер кɵрсɵтүлɵт",
      ended: "Бул жерде өтүп кеткен турнирлер көрсөтүлөт",
      future: "Бул жерде болуучу турнирлер көрсөтүлөт"
    },
    gamesNotFound: "Оюндар табылган жок",
    gamesSearch: "Суранычыңыз боюнча оюндар табылган жок, башка суранычты байкап көрүңүз",
    messages: "Сиздин билдирүүлөр бул жерде көрсөтүлөт",
    payin: "Сизде жеткиликтүү толуктоо ыкмалары жок",
    payout: "Сизде чыгаруунун жеткиликтүү ыкмалары жок",
    simple: "Жыйынтык жок",
    transactions: "Сиздин транзакцияларыңыз бул жерде көрсөтүлөт",
    withdraw: "Сиздин акчаны алуу өтүнүчтөрүңүз бул жерде көрсөтүлөт"
  },
  noSelectionsForBetting: "Коюм үчүн натыйжалар тандалган эмес",
  nomination: "Турнирдин номинациясы",
  nonBonusGame: "Оюн бонустук программага катышпайт. Сиздин эсебиңизди негизги эсепке которобуз.",
  nonBonusGameBetsNotCountInVager: "Оюн бонустук программага катышпайт. Коюмдар бонустун вейджеринде эске алынбайт",
  nonBonusGameWithoutBalance: "Оюн бонустук программага катышпайт. Ойнотуу үчүн, негизги эсепти толтуруңуз.",
  notBonuses: "Учурда жеткиликтүү бонустар жок",
  notCompetition: "Учурда активдүү турнирлер жок",
  notConfirmed: "Далилденген жок",
  notDeposit: "Толуктоолор болгон эмес",
  notEnoughEventsForExpress: "Экспресс үчүн окуялар жетишсиз",
  notEnoughEventsForSystem: "Система үчүн окуялар жетишсиз",
  notEnoughMoneyToWithdraw: "Чыгаруу үчүн акча жетишсиз",
  notEnoughVventsForSystem: "Система үчүн окуялар жетишсиз",
  notInterested: "Кызыктуу эмес",
  notLogin: "{name} логинин жазыңыз!",
  notNow: "Азыр эмес",
  notPass: "Сырсөздү жазыңыз!",
  notSufficient: "Жетишсиз",
  notValidValue: "Туура эмес маани",
  notification: "Билдирүү",
  november: "ноябрь",
  nowInLine: "Азыр сызыкта",
  nowPlayed: "Азыр ойнолду",
  numberErr: "Каттоо учурунда көрсөтүлгөн номерди текшериңиз",
  numberOfWallet: "Капчыктын номери",
  october: "октябрь",
  onAccountBK: "БКнын эсебинде:",
  oneClick: "Банкты бир баскыч менен көбөйт",
  online: "Онлайн",
  onlyForYou: "Бир гана Сиз үчүн",
  open: "Ачуу",
  openAppTrustWallet: "Тиркемени ачсаңыз, сизге жаңы капчыкты каттоо же бар капчыгыӊннызды калыбына келтирүү сыяктуу эки функция жеткиликтүү болот. \"Жаңы капчыкты түзүү\" баскычын басыӊыз",
  openEmail: "Email-ди ачуу",
  openGameNewTab: "Оюнду ачуу үчүн, баскычты басыңыз",
  openSafari: "Safari-де ачуу",
  openSafariIfAnotherBrowser: "Эгер сиз башка браузерде болсоңуз, бул баракты Safari браузеринде ачыңыз",
  openTelegramBot: "Телеграм-ботту ачуу",
  operations: "Операция",
  orders: "Тапшырык",
  ordinary: "Ординар",
  ordinarySeries: "Серия ординаров",
  other: "Башкалар",
  otherSections: "Башка бөлүмдөр",
  ourSocialMedia: "Биздин социалдык тармактар",
  ourSocialMediaShort: "Биздин социалдык тармактар",
  out: "Чыгуу",
  output: "Чыгаруу",
  outputModalTitle: "Чыгарууну тастыктоо",
  outputSuccess: "Каражаттады чыгаруу ийгиликтүү аяктады!",
  overallCoef: "Жалпы коэффициент",
  page: "Баракча",
  pageErr: "Барак табылган жок",
  pageErrDesc: "Бул бет өчүрүлгөн же туура эмес жазылган",
  pageNotFound: "Бул бет табылган жок!",
  pageNotFoundDesc: "Бул бет өчүрүлгөн же туура эмес жазылган",
  participant: "Катышуучу",
  participate: "Катышуу",
  passErr: "Сырсөздү унуттуңузбу?",
  passMessage: "Сырсөз сандарды жана чоң, кичине тамгаларды камтышы керек",
  passportIndex: "Паспорттун номуру / ID",
  password: "Сырсөз",
  passwordChanged: "Сырсɵз ɵзгɵртүлдү",
  passwordErr: "Каттоо",
  passwordNew: "Жаңы сырсɵз",
  passwordSuccess: "Сырсөз ийгиликтүү калыбына келтирилди",
  passwordTheSame: "Сыр сөз учурдагыдан айырмаланышы керек",
  past: "Өткөн",
  pay: "Төлөп берүү ",
  payBonusErr: "Бонусту сатып алуу үчүн, ____ кем эмес суммада депозит калды",
  payMethod: "Толуктоо ыкмасы",
  payMethods: "Толуктоо ыкмалары",
  paymentMethod: "Төлөө ыкмасы",
  paymentSuccess: "Каражаттарды которуу ийгиликтүү аяктады!",
  payoutPayTrxsExistsText: "Каражат чыгаруу үчүн, жок дегенде бир жолу толуктоо аткаруу керек",
  payoutThresholdStatusText: "Каражат чыгаруу үчүн ойноо керек {count}\n",
  period: "Убакытка тиешелүү",
  personInformationIsApprove: "Маалыматтар кабыл алынды, аккаунт корголду",
  personalArea: "Жеке кабинет",
  personalData: "Жеке маалыматтар",
  personalDataApproved: "Жеке маалыматтар тастыкталды",
  personalDataIsFilled: "Жеке маалыматтар толтурулду",
  personalDataSuccessfullyEdited: "Сиздин жеке маалыматтарыңыз ийгиликтүү ɵзгɵртүлдү",
  phone: "Телефон",
  phoneErr: "Телефон номуру тамгаларды камтыбайт!",
  phoneNum: "Телефон номуру",
  phoneSuccessfullyApproved: "Телефон ийгиликтүү тастыкталды",
  pickUpBonus: "Бонусту алуу",
  place: "Орун",
  placeAQuickBet: "Тез коюм коюуну каалайсызбы?",
  places: "Байгелүү орун:",
  placesCount: "{count} орун",
  placesPrice: "Байге",
  play: "Ойноо",
  playAviator: "Авиатор ойноо",
  playBonus: "Куттуктайбыз, бонусуңузду утуп алдыңыз! Акча каражаттарын алуу балансты {count} өлчөмүндө толтургандан кийин жеткиликтүү болот. Оюнду улантуу үчүн эсебиңизди {count} суммага толтуруңуз ",
  playBonusEnded: "Бонус бүттү. Оюнду улантуу үчүн эсепти {count} суммага толтуруңуз",
  playForMoney: "Акчага ойноо",
  playGamesInCategoryes: "Төмөнкү категориялардагы оюндарды ойноӊуз",
  playWithoutBonus: "Бонуссуз ойноо",
  playingInAppMoreConvenient: "Тиркемеде ойноо ыӊгайлууракк",
  pleaseConfirmAgreementToTheTerms: "Сураныч, шарттарга макулдугуӊузду тастыктаӊыз",
  pleaseConfirmInformation: "Сураныч, маалыматты тастыктаңыз",
  pleaseSelectOutcome: "Сураныч, оюндун аягын тандаңыз",
  pleaseUseNumberOfCharacters: "Сураныч, {num} символ колдонуңуз",
  point: "Упайлар",
  points: "упай жок | {n} упай | {n} упай | {n} упай",
  postSMS: "Смс-код жөнөтүү",
  posts: "Билдирүү",
  potentialWin: "Потенциалдуу утуш",
  ppenFullBetHistory: "Коюмдардын толук тарыхын ачуу",
  preparedForRemoval: "Чыгарууга даяр (иштетилүүдө)",
  preview: "Алдын ала көрүү",
  prize: "Байге",
  prizes: "Жеңүүчүлөрдүн байгелери",
  proceed: "Улантуу",
  processDeposit: "Толуктоону иштетүү",
  processDepositDescription: "Төлөм жөнөтүлдү жана төлөм системасынын тарабында иштетүүдө турат. Каражаттарды которуу бир нече мүнөттөн бир нече күнгө чейинки мөөнөттү түзүшү мүмкүн.",
  processWagerFromBonusBalance: "Бонустук баланстан вэйджерди аткаруу",
  processWagerFromDeposit: "Депозиттин суммасынан вэйджерди аткаруу",
  processed: "Иштетилүүдө",
  processing: "Иштетилип жатат",
  promo: "Акциялар",
  promoCodeActivationSuccess: "⁠Промокод ийгиликтүү активдештирилди",
  promoGames: "Бонус оюндары",
  promoMaxBetExceeded: "Кайра ойноого кетүүчү коюмдун максималдуу суммасы {bet} {currency}",
  promoNotFound: "Учурда акциялар жок",
  promocode: {
    activate: "Промокодду активдештирүү",
    placeholder: "Промокод",
    title: "Промокоддун активациясы"
  },
  promocodes: {
    NY25DAY1: "Santa's Gift оюнунда 50 FS",
    NY25DAY10: "Santa's Great Gifts оюнунда 50 FS",
    NY25DAY11: "Спортко фрибет!",
    NY25DAY12: "Royal Xmass 2 оюнунда 75 FS",
    NY25DAY13: "Депозитке 75% жана 75 FS белекке!",
    NY25DAY14: "Santa's Xmas Rush оюнунда 100 FS",
    NY25DAY2: "Депозитке 50% жана 50 FS белекке!",
    NY25DAY3: "Спортко фрибет!",
    NY25DAY4: "Buffalo Power: Christmas оюнунда 75 FS",
    NY25DAY5: "Депозитке 75% жана 75 FS белекке!",
    NY25DAY6: "Royal Xmass оюнунда 75 FS",
    NY25DAY7: "Депозитке 100% жана 100 FS белекке!",
    NY25DAY8: "Sugar Rush Xmas оюнунда 100 FS",
    NY25DAY9: "Депозитке 50% жана 50 FS белекке!\n\n",
    NYDAY1: "Hell Hot 100 оюнунда 50 FS",
    NYDAY10: "Santa's Great Gifts оюнунда 50 FS",
    NYDAY11: "Спортко фрибет!",
    NYDAY12: "Спортко фрибет!",
    NYDAY13: "Депозитке 75% жана 75 FS белекке!",
    NYDAY14: "Sugar Rush Xmas оюнунда 100 FS",
    NYDAY2: "Депозитке 50% жана 50 FS белекке!\n\n",
    NYDAY3: "Спортко фрибет!",
    NYDAY4: "JetX-те фрибеттер",
    NYDAY5: "Депозитке 75% жана 75 FS белекке!",
    NYDAY6: "Twin fruits of Santa оюнунда 75 FS",
    NYDAY7: "Депозитке 100% жана 100 FS белекке!",
    NYDAY8: "Sugar Rush Xmas оюнунда 100 FS",
    NYDAY9: "Депозитке 50% жана 50 FS белекке!\n\n"
  },
  promocodes2025: {
    NY25DAY1: "Santa's Gift оюнунда 50 FS",
    NY25DAY10: "Спортко​•​фрибет!",
    NY25DAY11: "Santa's​ Great​ Gifts​ оюнунда​ 50​ FS",
    NY25DAY12: "Royal Xmass 2 оюнунда 75 FS",
    NY25DAY13: "Депозитке 75% жана 75 FS белекке!",
    NY25DAY14: "Santa's Xmas Rush оюнунда 100 FS",
    NY25DAY2: "Спортко​•​фрибет!",
    NY25DAY3: "Депозитке​•​50%​•​жана​•​50​•​FS​•​белекке!",
    NY25DAY4: "Buffalo Power: Christmas оюнунда 75 FS",
    NY25DAY5: "Депозитке 75% жана 75 FS белекке!",
    NY25DAY6: "Royal Xmass оюнунда 75 FS",
    NY25DAY7: "Депозитке 100% жана 100 FS белекке!",
    NY25DAY8: "Sugar Rush Xmas оюнунда 100 FS",
    NY25DAY9: "Депозитке 50% жана 50 FS белекке!"
  },
  promotionNotFound: "Мындай акция жок",
  protectYouData: "Өздүк маалыматтарыңызды жана каражаттарыңызды коопсуздандырыңыз",
  protection: "Купуялык саясаты",
  protectionSettingsMessage: "Аккаунттун коопсуздугун ырастоо сиздин каражаттарыңызды сактоо жана аларды коопсуз чыгаруу үчүн зарыл",
  providers: "Провайдерлер",
  purchaseCryptocurrency: "Криптовалюта сатып алуу",
  putSend: "Кодду алуу",
  queue: "Кезекте",
  reSendCode: "Кодду кайрадан жөнөтүү",
  read: "Окулду",
  readyForWithdrawOnCashier: "Кассадан төлөөгө даяр",
  receiveWithdrawalConfirmation: "Электрондук почта/Telegram аркылуу акча каражаттарын чыгарууга тастыктоо алуу",
  recomend: "Сунуштайбыз",
  recovery: "Сырсөздү калыбына келтириүү",
  recoveryEmailDesc: "Аккаунтка жеткилик алуу үчүн, катталууда кɵрсɵткɵн email-ди жазыңыз",
  recoveryPassword: "Сыр сөздү калыбына келтирүү",
  recoveryPhoneDesc: "Каттоо эсебиңизге кирүү үчүн, каттоо учурунда көрсөткөн телефон номериңизди жазыңыз",
  recoveryWord: "Калыбына келтирүү",
  refill: "Эсепти толтуруу",
  refresh: "Жаңыртуу",
  refreshPage: "Баракчаны жаӊылоо",
  refund: "Кайтаруу",
  refundPolicy: "Кайтарып берүү саясаты",
  refundWithdrawal: "Чыгаруудан баш тартуу",
  refundWithdrawalModalDesc: "Сиз чынында акча чыгаруудан баш тартасызбы? Баш тартууда акча каражаттары\nбаланска кайтарылат.\n",
  refundWithdrawalNoun: "Чыгаруудан баш тартуу",
  reg: "Каттоо",
  register: "Катталуу",
  registrationBonus: "Катталуу үчүн бонус",
  rejected: "Четке кагылды",
  remainingPlay: "Ойноо калды",
  repeatPassword: "Сыр сөздү кайталаӊыз",
  repeatTopUpDesc: "Төлөм ишке ашпай калдыбы? Кайра аракет кылып көрөлү?",
  replenishment: "Толуктоо",
  requirement: "Талап",
  requisiteDesc: "Эсепти толуктоо үчүн эсепке {sum}которуӊуз. Ийгиликтүү толуктоо үчүн сумма көрсөтүлгөн суммага толук ылайык келиши керек.",
  resend: "Кайра жөнөтүү",
  resendCodeCanAfter: "Кодду кайрадан жөнөтүүгө чейин калган убакы {0}",
  reset: "Тазалоо",
  resetFilters: "Фильтрди жокко чыгаруу",
  resetIt: "аны нөлгө келтирүү",
  responsibleGame: "Жоопту оюн",
  result: "Жыйынтык",
  results: "Натыйжалар",
  resultsSearch: "Издөөнүн натыйжасы",
  "return": "Кайтаруу",
  rollback: "Кетенчиктөө",
  rules: "Эрежелер жана шарттар",
  rulesDescription: "Эрежелер",
  rulesShort: "Эрежелери",
  rulesTournament: "Турнирдин шарттары жана эрежелери",
  russian: "Орусча",
  sales: "Сатылды",
  save: "Сактоо",
  schedule: "Ырааттама",
  scores: "Упайлар",
  search: "Издөө",
  searchProviders: "Провайдердин аталышы",
  seats: "Орундар",
  secretAnswer: "Контролдук суроого жооп",
  secretQuestion: "Көзөмөлдүк суроо",
  security: {
    five: "Маалыматтарды коргоо боюнча дагы эле суроолоруңуз болсо, онлайн колдоо кызматы менен байланышыңыз же {support} дарегине электрондук кат жөнөтүңүз. Биз сизге жардам берүүгө кубанычтабыз.",
    one: "Биз бул купуялык билдирүүсүн дүйнөлүк стандарттар боюнча бизнес жүргүзүүгө бекем берилгендигибизди көрсөтүү үчүн жарыялап жатабыз.",
    seven: "Маалыматтарды коргоо",
    six: "Сайттагы кызматтар жана маалымат\" Euromirbet doo \", Podgorica, Cetinjski put bb, рег. № 5-0685623 / 1 тарабынан сунушталган. Payment Card Industry Security Standards Council сунуштарына ылайык, сатып алуучунун маалыматтарын коргоо үчүн шифрлөө транспорт деңгээлинде - TLS 1.2 жана 256 бит ачкыч узундугу менен AES алгоритмин колдонулат. ",
    three: "{titlePure} антиспам саясаты бар. Биздин оюнчуларга жөнөтүлгөн бардык каттар алардын оюн эсептерине тиешелүү, ошондой эле алардын казинодогу жаңы мүмкүнчүлүктөрү жана тиешелүү жарнамалык материалдар жөнүндө маалыматты камтышы мүмкүн. Жарнамалык жөнөтүүлөрдүн жыштыгы ар кандай болушу мүмкүн жана күнүнө 3 катка чейин жетет. Оюнчулар жазылууну токтотуу укугун өзүнө калтырат - бул учурда сиз онлайн колдоо кызматына кайрылышып, келген каттын ылдый жагындагы тиешелүү шилтемени басуу менен каалаган убакта жазылууну токтота аласыз. Сиздин утушуңуз жана сизге төлөнгөн төлөмдөрүңүз тууралуу маалымат да толугу менен купуя болуп, коопсуз чөйрөдө сакталат.",
    two: "Биз жакшы бизнес мамилелер чынчылдык жана ишеним менен гана курулат деп ишенебиз. Ошондуктан, маалыматыңыздын купуялуулугу биз үчүн өтө маанилүү. Сиздин транзакцияларыңыздын коопсуздугун камсыз кылуу үчүн бардык чараларды көрүп жатканыбызды билип, оюндан ырахат ала аласыз. Сиздин аты-жөнүңүз, почта дарегиңиз, e-mail дарегиңиз, телефон номуруңуз, туулган күнүңүз, жынысыңыз, IP дарегиңиз жана башка маалыматтар купуя жана жашыруун болуп саналат жана аларды үчүнчү жактарга өткөрүп берилбейт, сатылбайт же таратылбайт."
  },
  securityAnswer: "Сыр жооп",
  securityQuestion: "Сыр суроо ",
  securitySetting: "Коопсуздук ырастамалары",
  selectAll: "Баарын бөлүп көрсөтүү",
  selectApproveMethod: "Чыгарууну тастыктоо ыкмасын тандаӊыз",
  selectCountryToReceive: "Аймактагы актуалдуу сунуштарды жана шарттарды алуу үчүн, өлкөнү тандаӊыз",
  selectPaymentCurrencyAndClickTopUpAccount: "Төлөм валютасын тандап, \"Эсепти толуктоо\" баскычын басыңыз",
  selectProviders: "Тандалган провавйдерлер боюнча бардык оюндар",
  selectQuestion: "Алгач суроону тандап алыңыз",
  selectVariable: "Ылайыктуу вариантты тандаңыз",
  sellBet: "Коюмду сатуу",
  send: "Жөнөтүү",
  sendCode: "Кодду жɵнɵтүү",
  sendCodeError: "Кодду жазуу ишке ашкан жок, кайрылыӊыз ",
  sendCodeErrorSupport: "колдоого",
  sendCodeRepeat: "Кодду дагы бир жолу жөнөтүү",
  sendCodeSuccess: "Код телефонго жɵнɵтүлдү",
  sendCodeSuccessEmail: "Код почтага жɵнɵтүлдү",
  sendConfirmationEmail: "Биз …. дарегине тастыктоо менен email жɵнɵттүк",
  sendConfirmationPhone: "Биз {phone} номерине код менен смс жөнөттүк",
  sendDocuments: "Документтерди жөнөтүү",
  sendSMS: "SMS код жөнөтүү",
  sendedCodeToEmail: "Код почтага жөнөтүлдү <br> {email}",
  sendedCodeToPhone: "Код телефонго жөнөтүлдү <br> {phone}",
  september: "сентябрь",
  serverErrorTryAgain: "Сервердин катасы, дагы кайталап көрүңүз",
  serverErrorTryRefresh: "Сервердин катасы, жаңыртып көрүңүзь",
  settlementCurrency: "Эсептөөлөрдүн валютасы",
  sgtv_bonus: {
    block_one_li_four: "10 фрибет алыӊыз.",
    block_one_li_one: "Бонусту алуу үчүн баланста {sum} {currency} болушу керек.",
    block_one_li_three: "Менюдан бонусту активдештириӊиз.",
    block_one_li_two: "Бонсуту активдештирүү үчүн SGTV провайдеринин каалаган оюнуна өтүӊүз.",
    block_one_title: "Өз бонусуңузду кантип алсаңыз болот:",
    block_two_li_eight: "Бонуска вейджер х20 салынат. Кайра ойноодогу минималдуу коэффициент 1.5ке барабар.",
    block_two_li_eleven: "Olymp жалгыз жана каалаган учурда сунуштун шарттарын өзгөртүү же жокко чыгаруу, ошондой эле кайсы болбосун оюнчуга себептерин түшүндүрбөстөн баш тартуу укугун өзүнө калтырат.",
    block_two_li_five: "Sport Games бөлүмүнө кирүүгө жаӊы оюнчуга {sum} {currency} номиналы менен 10 фрибет эсептелет.",
    block_two_li_four: "Бонус дароо кошулат. Эгер тандалган бонус кошулган эмес болсо, оюн башталарга чейин колдоо кызматына кайрылуу керек. Эгер сиз оюнду бонуссуз баштасаӊыз, ал кошулбайт.",
    block_two_li_nine: "Депозитсиз фрибеттерден жана депозитсиз бонустардан чыгаруу үчүн максималдуу жеткиликтүү сумма - {sum} {currency}.",
    block_two_li_one: "Колдонуучунун бир гана бонуска укугу бар.",
    block_two_li_seven: "Бонус кошулган учурдан тартып 3 күндүн ичинде жеткиликтүү.",
    block_two_li_six: "Фрибеттерди «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты» оюндарынан колдонсо болот.",
    block_two_li_ten: "Фрибеттерди 1.3төн 5ке чейинки коэффициентке коюмдар үчүн колдонууга болот.",
    block_two_li_three: "Бонусту алуу үчүн {sum} {currency} суммасынан жогору толуктоо керек.",
    block_two_li_two: "Бонустар (фрибеттер) SportgamesTV-де бир дагы жолу коюм жасабаган оюнчуларга берилет.",
    block_two_title: "Шарттары жана жоболору:",
    important_text: "Маанилүү! Эгер сиз бонусту активдештирбестен оюнду баштасаӊыз, фрибеттер кошулбайт.",
    title: "SportGamesTVөдеги жаӊы оюнчулар үчүн фрибеттер! «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты» оюндарынан 10 акысыз коюм алыӊыз."
  },
  shallWePlay: "Келиңиз ойнойбуз?",
  shortDescription: "Кыскача баяндоо",
  show: "Көрсөтүү",
  showAll: "Бардыгын көрсөтүү",
  showBets: "Коюмдарды көрсөтүү",
  showCodeOnlyForOperator: "Тастыктоо кодун кассирден башка эч кимге билдирбеңиз",
  showGame: "Оюнду көрсөтүү",
  showGames: "Оюндарды көрсөтүү",
  showMatchesStarting: "- Башталып жаткан матчтарды көрсөтүү:",
  showMoreGames: "Көбүрөөк оюндарды көрсөтүү",
  showTerms: "Шарттарды көрсөтүү",
  showTransactions: "Транзакцияларды көрсөтүү",
  signUp: "Катталуу",
  signUpAndVerifyVolet: "Катталып, верификациядан өтүңүз, ал 15 мүнөттү ээлейт",
  signin: "Кирүү",
  silver: "Күмүш",
  slots: "Слоттор",
  smallDescription: "Турнирдин кыскача баяндоосу",
  smsCode: "Смс кодду алуу",
  smsInfo: "Сиздин номурга СМС код жөнөтүлөт",
  smsSendingDesc: "Номериңизге жөнөткөн кодду жазыңыз",
  smsVer: "Төлөмдөрдүн SMS текшерүүсү (верификациясы)",
  smsVerDisabled: "Төлөмдөрдү текшерүү SMS өчүрүлгөн",
  smsVerEnabled: "Төлөмдөрдү текшерүү SMS күйгүзүлгөн",
  socialAuthError: "Социалдык тармак аркылуу авторизацияланууда ката кетти",
  soonStarted: "Жакында башталат",
  sort: "Ылгоо",
  spaceNotAvailableForField: "Бул талаада боштуктарга жол берилбейт",
  specifyNumberYourPersonalCryptoWallet: "-",
  spinsBeforeCrediting: "Эсепке алууга чейин спиндердин саны:",
  sportErrorText: "Биз азыр «Спорт» бөлүмүн жаӊылап жатабыз, бирок жакын арада бардыгын калыбына келтиребиз.",
  sports: "Спорт",
  stakeHasBeenSuccessfully: "Сиздин коюмуңуз ийгиликтүү кабыл алынды!",
  startSecuritySetup: "Коопсуздук ырастамаларынан өтүү",
  stateOfAnAccount: "Эсептин абалы",
  status: "Статус",
  statusAcc: "Аккаунттун абалы",
  statusOfTransaction: "Транзакциянын статусу",
  statusSuccess: "Тастыкталды",
  statuses: {
    calculationInProgress: "Эсептөө жүрүп жатат",
    inProcess: "Процессте",
    notPayed: "Төлөнгөн жок",
    payed: "Төлөндү"
  },
  sub_telegram: "Телеграмга жазыл",
  success: "Аракет ийгиликтүү өттү",
  successEnterTournament: "Эң сонун, сиз турнирдесиз!",
  successPromoCode: "⁠Промокод ийгиликтүү активдештирилди",
  sufficient: "Жетиштүү",
  sum: "Суммасы",
  sumBet: "Коюмдун суммасы",
  sumMoreThanBalance: "Баланстагыдан көп сумма",
  sumWithdraw: "Төлөнүүчү сумма",
  support: "Колдоо",
  supportContact: "Колдоого кайрылуу",
  surname: "Фамилиясы",
  suspended: "Токтотулду",
  system: "Система",
  table: "Үстөл",
  tapOnHome: "\"Башкы экранга кошуу\" баскычын таптап, \"Бүттү\" баскычын таптаңыз",
  tapOnShareIcon: "Экрандын ылдый жагындагы менюдагы Бөлүшүү сөлөкөтүн таптаңыз. Диалог терезеси ачылат",
  term: "Эсепке киргизүү мөөнөтү",
  termEnrollment: "Эсепке алуу ыкмасы",
  termFulfillment: "Шарттарды аткаруу мөөнөтү:",
  termsAndConditions: "Шарттар жана жоболор",
  termsAndConditionsList: "Шарттары жана жоболору",
  timeFulfill: "Шарттарды аткарууга убакыт:",
  timeRemaining: {
    txt: "Кодду дагы алыш үчун {seconds} сек калды",
    txtPay: "Жаңы кодду {seconds} -дан кийин алсаңыз болот"
  },
  timeToActivateBonus: "Бонусту активдештирүү убактысы",
  timer: {
    oneLetter: {
      day: "д",
      hour: "ч",
      minute: "м",
      second: "с"
    },
    "short": {
      day: "күндөр",
      hour: "саат",
      minute: "мүнөт",
      second: "секунда"
    }
  },
  tip: "Чайпул",
  titles: {
    cashback: "Cashback",
    dropsWins: "Drops жана wins",
    err404: "Суралган баракча жок",
    fraud: "Алдамчылыктан коргоо",
    gameGroups: {
      "GamesByGroup\/slot": "Онлайн слоттор – оюн автоматтарын акчага, акысыз катталуусуз ойноо"
    },
    home: "{titlePure}",
    profile: "Профиль",
    protection: "Маалыматтарды коргоо",
    responsibleGame: "Жооптуу оюн",
    rules: "Эрежелер жана шарттар",
    tournaments: "Турнирлер",
    work: "Техникалык иштер жүрүп жатат"
  },
  to: "{date}-га чейин",
  toFindOutWalletAddressOfCoin: "Кандайдыр бир тыйындын капчык дарегин билүү үчүн, негизги экранда, сиз алууну каалаган тыйынды басып, андан кийин транзакциялар тарыхы менен бирге тыйындын баракчасы көрсөтүлөт",
  toPromoStart: "Акциянын башына чейин",
  toSupport: "колдоо кызматына",
  topLines: "Топ Сызыктар",
  topUp: "Толуктоо",
  topUpWith: "____ толуктоо",
  topupYourBalance: "Акчага ойноо үчүн, балансыңызды толуктаңыз",
  total: "Бардык",
  tournament: "Турнир",
  tournamentCryptoReminderText: "Утушуңузду алуу үчүн жеке кабинетиӊизден Doge крипто капчыгын көрсөтүүнү унутпаңыз ",
  tournamentDescription: "Турнирдин сүрɵттɵмɵсү",
  tournamentEnded: "Турнир аяктады",
  tournamentGame: "Оюн турнирге катышат",
  tournamentGames: "Турнирдин оюндары",
  tournamentMounth: {
    "01": "Январь",
    "02": "Февраль",
    "03": "Март",
    "04": "Апрель",
    "05": "Май",
    "06": "Июнь",
    "07": "Июль",
    "08": "Август",
    "09": "Сентябрь",
    "10": "Октябрь",
    "11": "Ноябрь",
    "12": "Декабрь"
  },
  tournaments: "Турнирлер",
  transactionCopied: "Транзакция идентификаторун көчүрдүңүз",
  transactionSuccess: "Транзакция ийгиликтүү аяктады",
  transactionsIsNotExist: "Сизде азырынча транзакция боло элек",
  transactionsNotFound: "Тандалган чыпкалар боюнча транзакциялар табылган жок. Чыпка же {0} параметрлерин түзөтүп көрүңүз",
  transfer: "Которуу",
  transferAccount: "Эсепке которуу",
  transferAmount: "Которуу суммасын жазыңыз",
  transferAmount2: "Которуу суммасын жазыңыз",
  transferSuccessfully: "Каражаттарды которуу ийгиликтүү аяктады!",
  transferTheMoneyAndWait: "Акчаны кассирге берип, капчыктын толукталышын күтүңүз",
  transitionDate: "Транзакциянын датасы",
  transitionStatus: "Транзакциянын статусу",
  transitionType: "Транзакция түрү",
  turnOff: "Eчүрүү",
  turnOn: "Kүйгүзүү",
  turnOnState: "Активдештирилген",
  turnover: "Жүгүртүү",
  twoFactorAuth: "Эки факторлуу аутентификация",
  typeOfTransaction: "Транзакциянын түрү",
  uncalculated: "Эсептелбеген",
  underCoinBalanceClickGetButton: "Тыйын балансынын астында \"Алуу\" баскычын басыӊыз.  Баскычты колдонуп даректи көчүрүп же сканерлөө үчүн штрих-кодду колдонушуңуз керек",
  unexpectedErrorWriteToSupport: "Күтүлбөгөн ката кетти, бирок биз баарын тез арада четтетебиз.",
  unexpected_error_try_again: "Күтүлбөгөн ката, кайталап көрүңүз",
  unhandledErrorTryToRefreshPage: "Күтүлбөгөн ката, баракты жаңыртып көрүңүз",
  unselect: "Бөлүп көрсөтүүнү алуу",
  untilStartLeft: "Баштоого чейин калды",
  update: "Жаңыртуу",
  upload: "Жүктөө",
  uzbek: "Өзбекче",
  verification: "Верификация",
  verificationDeclined: "Верификация жокко чыгарылды. Сураныч, колдоо кызматы менен байланышыңыз.",
  verificationDeclinedInfo: "Документтер текшерүүдөн өткөн жок. Сураныч, документтерди кайрадан тиркеңиз же колдоо кызматы менен байланышыңыз.",
  verificationInProgress: "Верификация аткарылып жатат. Сураныч, күтө туруңуз.",
  verificationsSMSDesc: "Төлөмдөрдү текшерүү үчүн, каттоо учурунда көрсөткөн телефон номериңизди ырастаңыз",
  verifyYourAccount: "Аккаунтуңду верификацияла",
  virtuals: "В-Спорт",
  wager: "Вейджер",
  wagerGame: {
    accessAfterRolePlay: "Оюн бонусту ойнотуу аяктагандан кийин жеткиликтүү болот",
    gamesWagering: "Коюм коюу мүмкүн болгон оюндар",
    nowPlayed: "Азыр ойнолду",
    remainForPlay: "Ойноо калды"
  },
  wallet: "Капчык",
  walletCopied: "Капчык көчүрүлдү",
  walletId: "Капчыктын дареги",
  walletNotLinked: "Капчык байланган эмес",
  way: "Чыгаруу ыкмасы",
  ways: "Чыгаруу ыкмасы",
  wbCashboxActiveText: "Бонустук эсепке 100% депозит алуу үчүн, эсепти {minSum}-дан жогору толтуруңуз. Негизги эсеп бонус ойнотулгандан кийин гана жеткиликтүү болот.",
  wbCashboxNotActiveText: "Бонустук эсепке депозитке 100% алуу үчүн бонусту жеке кабинеттен активдештириңиз.\n\n",
  wbWaitOnProfile: "Саламдашуу бонусу сизди жеке кабинетиңиздин «Бонустар» бөлүмүндө күтүп жатат",
  welcomeBonus: "Welcome бонусуӊду",
  welcomeBonusCasino: "Welcome бонусуӊду казино",
  welcomeBonusDescription: "Бир сааттын ичинде төлөм жүргүзүүгө жетишип, депозит үчүн <span class='text-accent'>125%</span>көбөйтүлгөн бонус жана 250 фриспинге чейин алыӊыз!",
  welcomeBonusSport: "Welcome бонусуӊду спорт",
  welcomeBonusTitle: "Welcome бонуска +25%",
  win: "Жеңиш",
  winnerPoints: "Жеңүүчүлөрдүн упайлары",
  winners: "Уткан",
  withAnIncrease: "Жогорулоодо",
  withDrawOrdered: "Чыгаруу таризделди",
  withDrawOrderedDesc: "Жакынкы арада каражаттар сиздин көрсөтүлгөн эсебиӊизге которулат.",
  withInstantCashback: "Заматта кэшбек менен",
  withdraw: "Чыгаруу",
  withdraw2: "____ чыгаруу",
  withdrawBK: "БКга чыгаруу",
  withdrawFunds: "Каражатты чыгаруу",
  withdrawMethod: "Чыгаруу ыкмасы",
  withdrawMethods: "Чыгаруу ыкмалары",
  withdrawNoun: "Чыгаруу",
  withdrawPaymentInfo: "Visa/Mastercard ыкмасы аркылуу каражаттарды чыгаруу логинге байланган картада гана жеткиликтүү. Байлоо үчүн Сиз логиниңизди Visa/Mastercard ыкмасы менен толуктооңуз керек. ",
  withdrawPerDayCountExceeded: "Сиз күн сайын 1 жолу каражат чыгара аласыз",
  withdrawTelegramBot: "Каражаттарды чыгаруу үчүн Телеграм-ботту иштетип, ага авторизациялануу керек",
  withdrawWithApprove: "Кодду тастыктоо менен каражат чыгаруу",
  withdrawWithCode: "Код менен тастыктоо аркылуу каражаттарды чыгаруу",
  withdrawal: "Каражаттарды чыгарууда чектөө",
  withdrawalCompletedSuccessfully: "Чыгууга үчүн буйрутма түзүлдү",
  withdrawalOfFunds: "Код менен тастыктоо аркылуу каражаттарды чыгаруу",
  work: "Техникалык иштер жүрүп жатат",
  writeToSupport: "Колдоого жазуу",
  yes: "Ооба",
  yesConfirm: "Ооба, туура",
  yesOfCourseIWant: "Ооба, албетте каалайм",
  yesRefundWithdrawal: "Ооба, чыгаруудан баш тартам",
  yesSure: "Ооба, толуктадым",
  you: "Сиз",
  youAreAuthorized: "Сиз авторизацияландыңыз",
  youAreParticipateInTheTournament: "Сиз турнирге катышып жатасыз!",
  youDontHaveTransactions: "Сизде азырынча эч кандай транзакция болгон жок",
  youHaveNewMessage: "Сизде жаңы билдирүү бар",
  youHaveNotNewMessages: "Жаңы билдирүүлөрүңүз жок",
  youHaveSmsVerification: "Сизде которууларды жүргүзүү үчүн төлөмдөрдү текшерүү иштетилген, SMS аркылуу текшерүүдөн өтүңүз",
  youTakePart: "Сиз катышасыз",
  yourBalance: "Сиздин балансыӊыз",
  yourCasinoBonus: "Сиздин казинодогу бонусуңуз",
  yourCurrentEmail: "Сидин учурдагы e-mail-иңиз",
  yourCurrentPhone: "Сиздин учурдагы номериңиз",
  yourEmail: "Сиздин email-иңиз",
  yourPersonalUniqueWalletIsDisplayedHere: "Бул жерде сиз мурда тандалган тыйын үчүн жеке уникалдуу капчыгыңыз көрсөтүлгөн. Капчыктын дарегин көчүрүү үчүн сиз атайын баскычты же QR кодун колдонсо болот."
} 
